import { createContext, useContext, useState } from "react";

const DICT = {
  it: {
    nav: { classes: "Esperienze", about: "Lo Chef", experience: "La Serata", gallery: "Galleria", testimonials: "Ospiti", book: "Prenota", admin: "Area Riservata" },
    hero: {
      overline: "Cooking experience privata · Piazza di Spagna",
      title: "Roma eterna,\ndal mio terrazzo.",
      sub: "Una cooking experience intima sopra i tetti del centro storico. Aperitivo al tramonto, pasta fresca a quattro mani, tiramisù e degustazione di ciò che hai creato.",
      cta: "Prenota un'esperienza",
      ctaGhost: "Scopri le esperienze",
    },
    ribbon: "Pasta fresca a mano · Vista su Piazza di Spagna · Ricette romane · Tiramisù d'autore · Ospiti, non clienti",
    classes: {
      overline: "I Pacchetti",
      title: "Tre esperienze per vivere\nRoma dal terrazzo.",
      coppie: { title: "Coppie · Romantico", persons: "2 persone", price: "170 € / persona", desc: "Cooking class privata di pasta fresca e tiramisù, degustazione sul terrazzo al tramonto con vista sui tetti del centro storico. Vini locali inclusi.", cta: "Prenota" },
      gruppo: { title: "Piccolo Gruppo", persons: "4–8 persone", price: "150 € / persona", desc: "Stessa esperienza in formato conviviale, ideale per famiglie o gruppi di amici in viaggio. Vini locali inclusi.", cta: "Prenota" },
      tartufo: { title: "Tartufo & Champagne", persons: "2–6 persone", price: "250 € / persona", desc: "Esperienza signature con degustazione di tartufo fresco, champagne in abbinamento, cooking class di pasta fresca e tiramisù, degustazione sul terrazzo al tramonto.", cta: "Prenota", badge: "Premium" },
      degustazione: { title: "Cena Degustazione", persons: "2–8 persone", price: "150 € / persona", desc: "Cena degustazione firmata dallo chef sul terrazzo al tramonto: antipasti, primo di pasta fresca, secondo romano, tiramisù. Rilassati e goditi il panorama — cuciniamo noi per te.", cta: "Prenota" },
      evento: { title: "Evento Privato / Aziendale", persons: "Su richiesta", price: "Su richiesta", desc: "Esperienza personalizzata per team building, celebrazioni, addii al celibato o al nubilato.", cta: "Scrivimi su WhatsApp" },
      note: "Menu e selezione vini personalizzabili in base alle preferenze e alle esigenze degli ospiti (allergie, intolleranze, richieste speciali). Contattaci per costruire l'esperienza su misura.",
      buildEvening: {
      navLink: "Build your evening",
      heroOverline: "Build your evening",
      heroTitle: "Costruisci la tua serata",
      heroSub: "Scegli l'esperienza, il menù e i vini. Caparra di 50 € online, saldo la sera sul terrazzo.",
      step1Title: "La tua esperienza",
      step2Title: "Il tuo menù",
      step3Title: "I tuoi vini",
      step4Title: "I tuoi dati",
      guestsLabel: "Ospiti",
      dateLabel: "Data",
      timeLabel: "Ora",
      perPerson: "/ persona",
      perBottle: "/ bottiglia",
      bottlesLabel: "bottiglie",
      bottleLabel: "bottiglia",
      guestsSuffix: "ospiti",
      wineNote: "I vini si pagano la sera direttamente al terrazzo.",
      experiences: {
        coppie: { title: "Coppie · Romantico", persons: "2 ospiti", desc: "La serata privata per due sul terrazzo al tramonto." },
        gruppo: { title: "Piccolo Gruppo", persons: "4–8 ospiti", desc: "Il formato conviviale per famiglie o amici in viaggio." },
      },
      menus: {
        tradizione: { name: "Tradizione Romana", desc: "Antipasti romani, pasta fresca (cacio e pepe o amatriciana), tiramisù, caffè e limoncello della casa." },
        pesce: { name: "Degustazione Pesce", desc: "Antipasti di mare, pasta fresca ai frutti di mare, dolce dello chef, caffè e limoncello della casa." },
        tartufo: { name: "Tartufo Bianco", desc: "Antipasti al tartufo, tagliolini al tartufo bianco fresco, tiramisù, caffè e limoncello della casa." },
      },
      wineCategories: {
        white: "Bianchi",
        red: "Rossi",
        rose: "Rosé",
        sparkling: "Spumanti",
        champagne: "Champagne",
      },
      summaryTitle: "La tua serata",
      experienceRow: "Esperienza",
      menuRow: "Menù",
      winesRow: "Vini",
      totalLabel: "Totale",
      depositLabel: "Caparra ora (Stripe)",
      balanceLabel: "Saldo la sera",
      formTitle: "Chi sei?",
      nameLabel: "Nome e cognome",
      emailLabel: "Email",
      phoneLabel: "Telefono (WhatsApp)",
      notesLabel: "Note (allergie, intolleranze, ricorrenze)",
      bookNow: "Prenota con caparra 50 €",
      bookingSuccess: "Perfetto! Ti stiamo portando al pagamento sicuro…",
      bookingError: "Qualcosa è andato storto. Riprova o scrivici su WhatsApp.",
      selectRequired: "Scegli esperienza, menù e data per continuare.",
      noWines: "Nessun vino selezionato (puoi anche portarti il tuo).",
      removeWine: "Rimuovi",
    },
    terraceTitle: "Il terrazzo",
      terraceSub: "A due passi da Piazza di Spagna, tra campanili e tetti del Seicento.",
      detailsCta: "Scopri di più",
    },
    experiences: {
      backToAll: "← Tutte le esperienze",
      backHome: "← Torna alla home",
      durationLabel: "Durata",
      guestsLabel: "Ospiti",
      priceLabel: "Prezzo",
      includesTitle: "Cosa è incluso",
      flowTitle: "Come si svolge la serata",
      whyTitle: "Perché scegliere questa esperienza",
      bookNow: "Prenota questa esperienza",
      otherTitle: "Altre esperienze sul terrazzo",
      badgePremium: "Premium",
      pageTitleSuffix: " · Eternal City View",
      coppie: {
        metaTitle: "Cooking Class Romantica a Roma per Coppie",
        metaDescription: "Serata privata sul terrazzo di Piazza di Spagna per due: pasta fresca a quattro mani, tiramisù, aperitivo al tramonto e cena con vista sui tetti di Roma.",
        heroTagline: "Solo voi due, il tramonto e Roma sotto il terrazzo.",
        descLong: "Una serata pensata per le coppie: cooking class privata con lo chef Alessandro, aperitivo al tramonto e cena a lume di candela sul terrazzo con vista panoramica sui tetti del centro storico. Perfetta per anniversari, proposte, lune di miele o semplicemente per un'esperienza indimenticabile a Roma.",
        duration: "≈ 3 ore",
        includes: [
          "Cooking class privata di pasta fresca a quattro mani",
          "Preparazione del tiramisù della casa",
          "Aperitivo al tramonto con calice di benvenuto",
          "Cena completa con vino dei Castelli, acqua e caffè",
          "Vista panoramica esclusiva sui tetti di Roma",
        ],
        flow: [
          "Accoglienza in terrazzo con calice al tramonto",
          "Cooking class: impasto, pasta e tiramisù",
          "Cena romantica con i piatti creati insieme",
          "Caffè, digestivo e lunghi saluti sotto le stelle",
        ],
        why: [
          "Massima privacy — solo voi due sul terrazzo",
          "Personalizzabile per anniversari o proposte",
          "Menù adattabile a intolleranze e preferenze",
        ],
      },
      gruppo: {
        metaTitle: "Cooking Class di Gruppo a Roma · Terrazzo Piazza di Spagna",
        metaDescription: "Esperienza culinaria conviviale per 4-8 persone sul terrazzo nel cuore di Roma: pasta fresca fatta a mano, tiramisù e cena al tramonto con vista panoramica.",
        heroTagline: "La vostra tribù, il terrazzo di Roma, una serata sola.",
        descLong: "L'esperienza perfetta per famiglie, amici in viaggio o piccoli gruppi che vogliono condividere qualcosa di davvero speciale. Cooking class conviviale con lo chef Alessandro sul terrazzo di Piazza di Spagna, aperitivo al tramonto e cena con i piatti preparati insieme.",
        duration: "≈ 3 ore",
        includes: [
          "Cooking class di gruppo di pasta fresca a mano",
          "Preparazione del tiramisù dello chef",
          "Aperitivo al tramonto con stuzzichini",
          "Cena completa con vino dei Castelli, acqua e caffè",
          "Vista panoramica sui tetti del centro storico",
        ],
        flow: [
          "Benvenuto in terrazzo con aperitivo",
          "Cooking class conviviale a più mani",
          "Cena di gruppo con i piatti creati",
          "Caffè, chiacchiere e amaro finale",
        ],
        why: [
          "Formato conviviale ideale per gruppi di amici",
          "Adatto a bambini (menù su misura)",
          "Un ricordo di Roma da portare a casa insieme",
        ],
      },
      tartufo: {
        metaTitle: "Esperienza Tartufo & Champagne a Roma · Cooking Class Premium",
        metaDescription: "Esperienza signature sul terrazzo di Piazza di Spagna: degustazione di tartufo fresco, champagne in abbinamento, cooking class di pasta fresca e cena al tramonto.",
        heroTagline: "Tartufo fresco, champagne e i tetti di Roma al tramonto.",
        descLong: "L'esperienza premium firmata Eternal City View: degustazione guidata di tartufo fresco, champagne in abbinamento, cooking class di pasta fresca al tartufo e cena esclusiva sul terrazzo con vista panoramica. Un evento su misura per palati esigenti o occasioni davvero speciali.",
        duration: "≈ 3,5 ore",
        includes: [
          "Degustazione guidata di tartufo fresco",
          "Calice di champagne in abbinamento",
          "Cooking class privata di pasta fresca al tartufo",
          "Tiramisù della casa e cena completa",
          "Vini selezionati, acqua e caffè",
          "Vista panoramica esclusiva sui tetti di Roma",
        ],
        flow: [
          "Aperitivo con champagne al tramonto",
          "Degustazione guidata di tartufo fresco",
          "Cooking class di pasta fresca al tartufo",
          "Cena signature con abbinamento vini",
          "Digestivo, dolce e lunghi saluti",
        ],
        why: [
          "Esperienza gourmet unica a Roma",
          "Ingredienti premium selezionati dallo chef",
          "Perfetta per occasioni celebrative",
        ],
      },
      degustazione: {
        metaTitle: "Cena Degustazione sul Terrazzo · Piazza di Spagna, Roma",
        metaDescription: "Cena degustazione firmata dallo chef sul terrazzo di Piazza di Spagna: antipasti, pasta fresca, secondo romano, tiramisù. Rilassati — cuciniamo noi per te.",
        heroTagline: "Siediti, brinda e lasciati guidare dallo chef.",
        descLong: "Nessuna cooking class: solo tu, i tuoi ospiti e la cucina dello chef. Una cena degustazione completa sul terrazzo al tramonto, con menù a più portate ideato da Alessandro. Perfetta per chi vuole godersi Roma senza pensieri, con la stessa cura di una tavola di famiglia ma con la mano di uno chef.",
        duration: "≈ 2,5 ore",
        includes: [
          "Antipasti dello chef",
          "Primo di pasta fresca fatta a mano",
          "Secondo della tradizione romana",
          "Tiramisù della casa",
          "Vino dei Castelli, acqua e caffè",
          "Servizio al tavolo sul terrazzo",
        ],
        flow: [
          "Aperitivo di benvenuto al tramonto",
          "Antipasti dello chef",
          "Primo e secondo serviti al tavolo",
          "Dolce, caffè e digestivo finale",
        ],
        why: [
          "Ideale per chi cerca solo la cena (nessuna cooking class)",
          "Menù stagionale creato dallo chef",
          "Ritmo rilassato, vista panoramica",
        ],
      },
    },
    about: { overline: "Lo Chef", title: "Sono Alessandro.\nBenvenuto sul mio terrazzo.", body: "Cucino da quando ero un ragazzino, nel ristorante di mia madre — cucina tipica romana, vera, senza compromessi. Mi sono diplomato all'Italian Chef Academy e ho fatto strada tra catering e cucine d'autore.\n\nOggi ho deciso di portare tutto questo a casa mia, sul terrazzo a due passi da Piazza di Spagna. Niente più sale affollate: solo te, i tuoi ospiti, i tetti di Roma e una cena cucinata come si fa in famiglia — ma con la mano dello chef.", signature: "— Alessandro Pivano" },
    experience: {
      seo: "Cerchi una cooking class privata a Roma vicino a Piazza di Spagna? Eternal City View offre un'esperienza intima sul terrazzo a due passi dai Trinità dei Monti — pasta fatta a mano, ricette della cucina romana e una cena al tramonto con vista panoramica sul centro storico. A differenza delle grandi scuole di cucina per gruppi, questa è una serata privata, condotta dallo chef, per coppie, famiglie e piccoli gruppi in visita a Roma.",
      overline: "La Serata",
      title: "Non un ristorante.\nUna serata a casa mia.",
      items: [
        { tag: "01", title: "Aperitivo", text: "Ti accolgo in terrazzo con un calice e qualche stuzzichino, mentre il sole cala su Piazza di Spagna." },
        { tag: "02", title: "Cuciniamo insieme", text: "Per la cooking class: un tipo di pasta fresca a quattro mani, e poi il tiramisù. Tecniche da chef, ritmo da casa." },
        { tag: "03", title: "A tavola", text: "Si cena con i piatti che hai creato (o quelli firmati dallo chef), accompagnati da vino dei Castelli e pane caldo." },
        { tag: "04", title: "Saluti lunghi", text: "Caffè, magari un amaro, e due chiacchiere per chiudere la serata come si deve." },
      ],
    },
    gallery: { overline: "Galleria", title: "Il terrazzo, i piatti,\nla luce di Roma.", sub: "Momenti veri delle serate sul terrazzo. Tocca un'immagine per ingrandirla.", close: "Chiudi", prev: "Precedente", next: "Successiva" },
    testimonials: {
      overline: "Gli Ospiti",
      shareTitle: "Hai cenato sul terrazzo?",
      shareSub: "Lascia una recensione, mi aiuti a far conoscere il progetto.",
      shareCta: "Lascia una recensione",
      orGoogle: "oppure su Google",
      shareSection: "Sei stato ospite?",
      emptyTitle: "Le voci dei primi ospiti\nappariranno qui.",
      emptySub: "Eternal City View ha appena aperto le porte del terrazzo. Se hai cenato qui, la tua recensione sarà la prima a essere letta da chi sta scoprendo il progetto.",
      emptyCta: "Sii il primo a raccontarla",
    },
    reviews: { overline: "Recensioni", formTitle: "La tua recensione", formSub: "Pubblicherò la tua recensione dopo una rapida revisione. Grazie di cuore — il passaparola è la cosa più preziosa per chi fa questo mestiere.", rating: "Voto", name: "Nome", namePh: "Es. Marco R.", origin: "Città", originPh: "Es. Roma, Boston…", text: "La tua esperienza", textPh: "Cosa ti è rimasto della serata? Ricetta, atmosfera, vista, qualunque cosa…", submit: "Invia recensione", sending: "Invio…", cancel: "Annulla", success: "Grazie! Pubblicherò la tua recensione dopo una rapida revisione.", error: "Qualcosa non ha funzionato. Riprova.", errorRating: "Scegli un voto da 1 a 5 stelle.", errorQuote: "Scrivi almeno una decina di caratteri." },
    booking: {
      overline: "Prenota", title: "Scegli la tua serata.", sub: "Una sola prenotazione al giorno per dedicarti la mia attenzione esclusiva. Blocca la tua data con una caparra di 50 € — conferma immediata.",
      name: "Nome e cognome", email: "Email", phone: "Telefono (WhatsApp)",
      classType: "Quale pacchetto", coppie: "Coppie · Romantico", gruppo: "Piccolo gruppo", tartufo: "Tartufo & Champagne", degustazione: "Cena Degustazione", evento: "Evento privato/aziendale",
      date: "Data preferita", pickDate: "Scegli una data", invalidEmail: "Indirizzo email non valido — controlla e riprova", slot: "Orario preferito", slotHint: "Es. 13:00 per pranzo, 19:30 per cena — ne discutiamo insieme.",
      guests: "Numero ospiti", message: "Messaggio (allergie, occasioni, note)",
      submit: "Invia richiesta", sending: "Invio in corso…", success: "Richiesta inviata! Ti scrivo entro 24 ore.", error: "Qualcosa non ha funzionato. Riprova.",
      confirmedTitle: "Richiesta ricevuta!", confirmedSub: "Grazie. Ti rispondo personalmente entro 24 ore via email o WhatsApp per confermare disponibilità e dettagli.",
      depositTitle: "Vuoi bloccare la data adesso?", depositSub: "Per confermare la prenotazione e tenere il terrazzo solo per te, puoi versare la caparra in modo sicuro tramite Stripe.", depositCta: "Versa la caparra", depositSecure: "Pagamento sicuro via Stripe", newBooking: "Nuova richiesta",
      payButton: "Prosegui al pagamento", payAmount: "Caparra 50 €", payHint: "Verrai reindirizzato a Stripe per completare il pagamento in sicurezza.",
      paidTitle: "Prenotazione confermata!", paidSub: "La tua caparra è stata registrata e la data è ufficialmente bloccata sul terrazzo. Riceverai l'indirizzo esatto e tutti i dettagli via email 48 ore prima dell'esperienza.",
      cancelTitle: "Pagamento annullato",
      cancelSub: "Nessun addebito effettuato. La tua richiesta rimane in attesa: puoi completare il pagamento più tardi o contattarci direttamente su WhatsApp.",
      retry: "Riprova pagamento", backHome: "Torna alla home", checkingPayment: "Verifica pagamento in corso…",
    },
    faq: {
      overline: "Domande frequenti", title: "Prima di prenotare.",
      items: [
        { q: "Dove si trova il terrazzo?", a: "Nel cuore del centro storico, a due passi da Piazza di Spagna. L'indirizzo esatto te lo invio alla conferma." },
        { q: "Cosa è incluso?", a: "Aperitivo iniziale, tutti gli ingredienti, vino dei Castelli, acqua e caffè. Nessun costo nascosto." },
        { q: "Intolleranze e vegetariani?", a: "Assolutamente sì. Scrivimelo nel messaggio e adatto il menu — sono uno chef, non un problema." },
        { q: "E se piove?", a: "Sul terrazzo c'è una zona coperta. In caso di maltempo serio spostiamo tutto in cucina, che è comunque parte dell'esperienza." },
        { q: "Come si paga?", a: "Alla conferma chiedo un piccolo anticipo via bonifico o PayPal. Il saldo la sera stessa, in contanti o con carta." },
        { q: "Quanti minimo?", a: "Da 2 ospiti in su. Massimo 6 per la cooking class, 8 per la degustazione." },
      ],
    },
    google: { overline: "Recensioni Google", basedOn: "Basato su {{n}} recensioni verificate", verifiedOnGoogle: "Verificato su Google", writeReview: "Scrivi una recensione" },
    footer: { tagline: "Cooking experience private · Piazza di Spagna, Roma", rights: "Tutti i diritti riservati.", contacts: "Contatti", cookiePolicy: "Cookie Policy", cookieSettings: "Preferenze cookie" },
    cookies: {
      bannerTitle: "Utilizziamo i cookie",
      bannerBody: "Usiamo cookie tecnici necessari al funzionamento del sito e, con il tuo consenso, cookie analitici per capire come viene usato. Nessun cookie di profilazione pubblicitaria.",
      readPolicy: "Leggi la Cookie Policy",
      acceptAll: "Accetta tutti",
      rejectAll: "Rifiuta",
      customize: "Personalizza",
      prefsOverline: "Preferenze",
      prefsTitle: "Gestisci i cookie",
      prefsSub: "Scegli quali cookie vuoi consentire. Puoi cambiare idea in qualsiasi momento dal link nel footer.",
      necessaryTitle: "Cookie necessari",
      necessaryDesc: "Indispensabili per il funzionamento del sito (lingua, preferenze, pagamenti sicuri). Non richiedono consenso.",
      analyticsTitle: "Cookie analitici",
      analyticsDesc: "Google Analytics e PostHog per misurare in forma anonima come viene usato il sito e migliorarlo. IP anonimizzato.",
      alwaysActive: "Sempre attivi",
      savePrefs: "Salva preferenze",
    },
    cookiePolicy: {
      overline: "Informativa",
      title: "Cookie Policy",
      lastUpdated: "Ultimo aggiornamento",
      updateDate: "Febbraio 2026",
      back: "Torna alla home",
      intro: "Questa Cookie Policy spiega quali cookie e tecnologie simili utilizza il sito eternalcityview.com (di seguito \"il Sito\"), gestito da Alessandro Pivano. Il Sito è progettato per rispettare la tua privacy: nessun cookie non necessario viene installato senza il tuo consenso esplicito.",
      whatAreTitle: "Cosa sono i cookie",
      whatAreBody: "I cookie sono piccoli file di testo che i siti visitati inviano al tuo dispositivo, dove vengono memorizzati per essere ritrasmessi agli stessi siti alla successiva visita. Utilizziamo anche tecnologie simili (localStorage) per memorizzare le tue preferenze.",
      typesTitle: "Tipologie di cookie utilizzati",
      necessaryTitle: "Cookie tecnici (necessari)",
      necessaryBody: "Necessari per il funzionamento del Sito, la memorizzazione della lingua scelta e per l'elaborazione dei pagamenti in sicurezza tramite Stripe. Non richiedono consenso ai sensi dell'art. 122 del Codice Privacy.",
      analyticsTitle: "Cookie analitici (opzionali)",
      analyticsBody: "Utilizziamo Google Analytics 4 e PostHog per raccogliere informazioni aggregate e anonime su come i visitatori usano il Sito (pagine visitate, durata delle sessioni, dispositivo, provenienza). L'IP viene anonimizzato. Questi cookie vengono installati solo previo tuo consenso.",
      tableTitle: "Cookie utilizzati dal Sito",
      thName: "Nome",
      thProvider: "Fornitore",
      thPurpose: "Finalità",
      thDuration: "Durata",
      rowGaPurpose: "Statistiche di utilizzo aggregate e anonime (analitico)",
      rowPhPurpose: "Product analytics e session replay anonimizzato",
      rowConsentPurpose: "Memorizza le tue preferenze sui cookie",
      rowLangPurpose: "Memorizza la lingua selezionata",
      rowStripePurpose: "Elaborazione sicura dei pagamenti (caparra)",
      duration2y: "2 anni",
      duration1y: "1 anno",
      duration6m: "6 mesi",
      durationPersistent: "Persistente",
      manageTitle: "Come gestire il consenso",
      manageBody: "Puoi modificare o revocare in qualsiasi momento le tue preferenze cliccando sul pulsante qui sotto.",
      manageCta: "Gestisci preferenze cookie",
      browserNote: "Puoi inoltre bloccare o eliminare i cookie direttamente dalle impostazioni del tuo browser (Chrome, Safari, Firefox, Edge, ecc.). Ricorda che la disabilitazione dei cookie tecnici può compromettere il corretto funzionamento del Sito.",
      rightsTitle: "I tuoi diritti (GDPR)",
      rightsBody: "In conformità al Regolamento UE 2016/679 (GDPR), hai diritto di accesso, rettifica, cancellazione, limitazione e portabilità dei tuoi dati personali, oltre al diritto di opposizione e di reclamo all'Autorità Garante per la Protezione dei Dati Personali.",
      contactTitle: "Contatti",
      contactBody: "Per qualsiasi domanda relativa a questa Cookie Policy o al trattamento dei tuoi dati, puoi scriverci a",
    },
    floating: { question: "Una domanda veloce?", sub: "Scrivimi su WhatsApp, ti rispondo personalmente.", cta: "Apri WhatsApp", greeting: "Ciao Alessandro, vorrei informazioni sui corsi di cucina sul terrazzo.", emailSub: "Preferisci l'email? Scrivimi, ti rispondo entro poche ore.", emailCta: "Apri Email", emailSubject: "Informazioni corsi di cucina sul terrazzo", emailBody: "Ciao Alessandro,\n\nvorrei informazioni sui corsi di cucina sul terrazzo.\n\nGrazie," },
    admin: {
      addReview: "+ Aggiungi recensione", cancel: "Annulla", publish: "Pubblica", addReviewValidation: "Compila nome, città e testo (min 10 caratteri).", addReviewSuccess: "Recensione pubblicata", reviewLanguage: "Lingua",
      gallery: "Galleria", uploadPhotos: "Carica foto", noPhotos: "Nessuna foto ancora.",
      availability: "Disponibilità",
      activeWeekdays: "Giorni attivi", timeRange: "Fascia oraria", maxPerDay: "Max eventi al giorno", saveConfig: "Salva configurazione", configSaved: "Configurazione salvata",
      weekdays: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"],
      blockedDates: "Date bloccate", addBlockedDate: "Aggiungi data", blockedReason: "Motivo (opzionale)", noBlockedDates: "Nessuna data bloccata.", blockedRemove: "Rimuovi",
      calendarView: "Calendario", listView: "Elenco",
      editBooking: "Modifica prenotazione", refundBooking: "Rimborsa e annulla", refundConfirm: "Vuoi rimborsare €50 e annullare questa prenotazione?", refundSuccess: "Rimborso effettuato", saveChanges: "Salva modifiche", changesSaved: "Modifiche salvate",
      bookingDetails: "Dettagli prenotazione", noBookingOnDate: "Nessuna prenotazione in questa data.",
      title: "Area Riservata", loginTitle: "Accesso", password: "Password", login: "Entra", logout: "Esci",
      bookings: "Prenotazioni", reviewsTitle: "Recensioni", noBookings: "Nessuna prenotazione.", noReviews: "Nessuna recensione.", wrongPassword: "Password non valida.",
      columns: { date: "Data", slot: "Orario", class: "Esperienza", guests: "Ospiti", name: "Nome", contact: "Contatto", message: "Note", received: "Ricevuta", status: "Stato", actions: "Azioni" },
      reviewColumns: { rating: "Voto", name: "Nome", origin: "Città", quote: "Testo", received: "Ricevuta", status: "Stato", actions: "Azioni" },
      statuses: { pending: "In attesa", abandoned: "Abbandonata", expired: "Scaduta", pending_payment: "In attesa pagamento", failed: "Fallita", confirmed: "Confermata", cancelled: "Annullata", approved: "Approvata", rejected: "Rifiutata" },
      confirm: "Conferma", cancel: "Annulla", delete: "Elimina", approve: "Approva", reject: "Rifiuta", all: "Tutte",
    },
  },

  en: {
    nav: { classes: "Experiences", about: "The Chef", experience: "The Evening", gallery: "Gallery", testimonials: "Guests", book: "Book", admin: "Admin" },
    hero: { overline: "Private cooking experience · Piazza di Spagna", title: "Eternal Rome,\nfrom my rooftop.", sub: "An intimate cooking experience above the rooftops of the historic center. Sunset aperitivo, fresh pasta made with the chef, tiramisù, and tasting of what you created.", cta: "Book an evening", ctaGhost: "See the experiences" },
    ribbon: "Handmade fresh pasta · Piazza di Spagna views · Roman recipes · Signature tiramisù · Guests, not customers",
    classes: {
      overline: "The Packages", title: "Three experiences to live\nRome from the rooftop.",
      coppie: { title: "Couples · Romantic", persons: "2 people", price: "€170 / person", desc: "Private fresh pasta and tiramisù cooking class, sunset tasting on the terrace with views over the rooftops of the historic center. Local wines included.", cta: "Book" },
      gruppo: { title: "Small Group", persons: "4–8 people", price: "€150 / person", desc: "The same experience in a convivial format, ideal for families or groups of friends traveling together. Local wines included.", cta: "Book" },
      tartufo: { title: "Truffle & Champagne", persons: "2–6 people", price: "€250 / person", desc: "Signature experience with fresh truffle tasting, matched champagne, fresh pasta & tiramisù cooking class, sunset tasting on the terrace.", cta: "Book", badge: "Premium" },
      degustazione: { title: "Tasting Dinner", persons: "2–8 people", price: "€150 / person", desc: "Chef-curated tasting dinner on the rooftop at sunset: antipasti, fresh-pasta main, Roman second course, tiramisù. Sit back and enjoy the view — we cook for you.", cta: "Book" },
      evento: { title: "Private / Corporate Event", persons: "On request", price: "On request", desc: "Bespoke experience for team building, celebrations, bachelor or bachelorette parties.", cta: "Message on WhatsApp" },
      note: "Menu and wine selection can be tailored to your preferences and needs (allergies, intolerances, special requests). Contact us to build a bespoke experience.",
      buildEvening: {
      navLink: "Build your evening",
      heroOverline: "Build your evening",
      heroTitle: "Design your evening",
      heroSub: "Pick experience, menu and wines. €50 deposit online, balance on the night at the terrace.",
      step1Title: "Your experience",
      step2Title: "Your menu",
      step3Title: "Your wines",
      step4Title: "Your details",
      guestsLabel: "Guests",
      dateLabel: "Date",
      timeLabel: "Time",
      perPerson: "/ person",
      perBottle: "/ bottle",
      bottlesLabel: "bottles",
      bottleLabel: "bottle",
      guestsSuffix: "guests",
      wineNote: "Wines are paid on the night directly at the terrace.",
      experiences: {
        coppie: { title: "Couples · Romantic", persons: "2 guests", desc: "A private sunset evening for two on the terrace." },
        gruppo: { title: "Small Group", persons: "4–8 guests", desc: "The convivial format for families or travelling friends." },
      },
      menus: {
        tradizione: { name: "Roman Tradition", desc: "Roman antipasti, fresh pasta (cacio e pepe or amatriciana), tiramisù, coffee and house-made limoncello." },
        pesce: { name: "Seafood Tasting", desc: "Seafood antipasti, fresh pasta with shellfish, chef's dessert, coffee and house-made limoncello." },
        tartufo: { name: "White Truffle", desc: "Truffle antipasti, tagliolini with fresh white truffle, tiramisù, coffee and house-made limoncello." },
      },
      wineCategories: { white: "White", red: "Red", rose: "Rosé", sparkling: "Sparkling", champagne: "Champagne" },
      summaryTitle: "Your evening",
      experienceRow: "Experience",
      menuRow: "Menu",
      winesRow: "Wines",
      totalLabel: "Total",
      depositLabel: "Deposit now (Stripe)",
      balanceLabel: "Balance on the night",
      formTitle: "Who are you?",
      nameLabel: "Full name",
      emailLabel: "Email",
      phoneLabel: "Phone (WhatsApp)",
      notesLabel: "Notes (allergies, intolerances, celebrations)",
      bookNow: "Book with €50 deposit",
      bookingSuccess: "Perfect! Taking you to the secure payment…",
      bookingError: "Something went wrong. Please retry or write us on WhatsApp.",
      selectRequired: "Pick an experience, a menu and a date to continue.",
      noWines: "No wines selected (you can also bring your own).",
      removeWine: "Remove",
    },
    terraceTitle: "The terrace",
      terraceSub: "Steps from Piazza di Spagna, among bell towers and 17th-century rooftops.",
      detailsCta: "Learn more",
    },
    experiences: {
      backToAll: "← All experiences",
      backHome: "← Back to home",
      durationLabel: "Duration",
      guestsLabel: "Guests",
      priceLabel: "Price",
      includesTitle: "What's included",
      flowTitle: "How the evening unfolds",
      whyTitle: "Why choose this experience",
      bookNow: "Book this experience",
      otherTitle: "Other experiences on the rooftop",
      badgePremium: "Premium",
      pageTitleSuffix: " · Eternal City View",
      coppie: {
        metaTitle: "Romantic Cooking Class in Rome for Couples",
        metaDescription: "Private evening on the rooftop by the Spanish Steps for two: hands-on fresh pasta, tiramisù, sunset aperitivo and dinner with panoramic views over Rome.",
        heroTagline: "Just the two of you, the sunset and Rome below.",
        descLong: "An evening designed for couples: private cooking class with chef Alessandro, sunset aperitivo and candlelit dinner on the rooftop with panoramic views over the historic center. Perfect for anniversaries, proposals, honeymoons or simply an unforgettable evening in Rome.",
        duration: "≈ 3 hours",
        includes: [
          "Private hands-on fresh pasta cooking class",
          "House tiramisù preparation",
          "Sunset aperitivo with a welcome glass",
          "Full dinner with Castelli wine, water and coffee",
          "Exclusive panoramic view over the rooftops of Rome",
        ],
        flow: [
          "Welcome on the terrace with a sunset glass",
          "Cooking class: dough, pasta and tiramisù",
          "Romantic dinner with the plates you created",
          "Coffee, digestivo and long goodbyes under the stars",
        ],
        why: [
          "Full privacy — just the two of you on the rooftop",
          "Customisable for anniversaries or proposals",
          "Menu adapted to allergies and preferences",
        ],
      },
      gruppo: {
        metaTitle: "Small Group Cooking Class in Rome · Piazza di Spagna Rooftop",
        metaDescription: "Convivial cooking experience for 4-8 people on the rooftop in the heart of Rome: handmade fresh pasta, tiramisù and sunset dinner with panoramic views.",
        heroTagline: "Your crew, the Rome rooftop, one unforgettable evening.",
        descLong: "The perfect experience for families, travelling friends or small groups who want to share something truly special. Convivial cooking class with chef Alessandro on the terrace by Piazza di Spagna, sunset aperitivo and dinner with the dishes you prepared together.",
        duration: "≈ 3 hours",
        includes: [
          "Group cooking class of handmade fresh pasta",
          "Chef's tiramisù preparation",
          "Sunset aperitivo with bites",
          "Full dinner with Castelli wine, water and coffee",
          "Panoramic views over the historic center rooftops",
        ],
        flow: [
          "Welcome on the terrace with aperitivo",
          "Convivial hands-on cooking class",
          "Group dinner with the plates you created",
          "Coffee, chatter and a final digestivo",
        ],
        why: [
          "Convivial format ideal for groups of friends",
          "Family friendly (menu tailored for kids)",
          "A memory of Rome to take home together",
        ],
      },
      tartufo: {
        metaTitle: "Truffle & Champagne Experience in Rome · Premium Cooking Class",
        metaDescription: "Signature experience on the rooftop by Piazza di Spagna: fresh truffle tasting, paired champagne, fresh pasta cooking class and sunset dinner.",
        heroTagline: "Fresh truffle, champagne and the Rome rooftops at sunset.",
        descLong: "The signature premium experience by Eternal City View: guided fresh truffle tasting, matched champagne, truffle pasta cooking class and an exclusive dinner on the rooftop with panoramic views. A bespoke event for refined palates or truly special occasions.",
        duration: "≈ 3.5 hours",
        includes: [
          "Guided fresh truffle tasting",
          "Paired glass of champagne",
          "Private truffle fresh pasta cooking class",
          "House tiramisù and full dinner",
          "Selected wines, water and coffee",
          "Exclusive panoramic view over Rome",
        ],
        flow: [
          "Champagne aperitivo at sunset",
          "Guided fresh truffle tasting",
          "Truffle fresh pasta cooking class",
          "Signature dinner with wine pairings",
          "Digestivo, dessert and long goodbyes",
        ],
        why: [
          "A unique gourmet experience in Rome",
          "Premium ingredients hand-picked by the chef",
          "Perfect for celebratory occasions",
        ],
      },
      degustazione: {
        metaTitle: "Tasting Dinner on the Rooftop · Piazza di Spagna, Rome",
        metaDescription: "Chef-curated tasting dinner on the rooftop by Piazza di Spagna: antipasti, fresh pasta, Roman second course, tiramisù. Sit back — we cook for you.",
        heroTagline: "Sit down, toast and let the chef take the lead.",
        descLong: "No cooking class this time: just you, your guests and the chef's kitchen. A full multi-course tasting dinner on the sunset rooftop, with a menu designed by Alessandro. Perfect for those who want to enjoy Rome hassle-free, with the care of a family table but a chef's precision.",
        duration: "≈ 2.5 hours",
        includes: [
          "Chef's antipasti",
          "Fresh handmade pasta main",
          "Roman tradition second course",
          "House tiramisù",
          "Castelli wine, water and coffee",
          "Table service on the terrace",
        ],
        flow: [
          "Welcome aperitivo at sunset",
          "Chef's antipasti",
          "Main and second course served at the table",
          "Dessert, coffee and final digestivo",
        ],
        why: [
          "Perfect for those who want dinner only (no cooking class)",
          "Seasonal menu curated by the chef",
          "Relaxed pace, panoramic view",
        ],
      },
    },
    about: { overline: "The Chef", title: "I'm Alessandro.\nWelcome to my rooftop.", body: "I've been cooking since I was a kid, in my mother's restaurant — traditional Roman cuisine, no shortcuts. I graduated from the Italian Chef Academy and worked my way through catering and high-end kitchens.\n\nToday I've decided to bring all of that home, on my terrace just steps from Piazza di Spagna. No more crowded dining rooms: just you, your guests, the rooftops of Rome and a dinner cooked the way it's done in family — but with a chef's hand.", signature: "— Alessandro Pivano" },
    experience: {
      seo: "Looking for a private cooking class in Rome near the Spanish Steps? Eternal City View offers an intimate rooftop experience just steps from Piazza di Spagna — handmade pasta, Roman recipes, and a sunset dinner with panoramic views over the historic center. Unlike large group cooking schools, this is a private, chef-led evening for couples, families, and small groups visiting Rome.",
      overline: "The Evening", title: "Not a restaurant.\nA night at my place.",
      items: [
        { tag: "01", title: "Aperitivo", text: "I welcome you on the terrace with a glass and a few bites, while the sun sets over Piazza di Spagna." },
        { tag: "02", title: "We cook together", text: "For the cooking class: one type of fresh pasta side by side, then tiramisù. Chef techniques, family pace." },
        { tag: "03", title: "At the table", text: "We dine on what you created (or what the chef plates), with Castelli wine and warm bread." },
        { tag: "04", title: "Long goodbyes", text: "Coffee, maybe a digestivo, and long conversations to close the evening the right way." },
      ],
    },
    gallery: { overline: "Gallery", title: "The terrace, the plates,\nthe Roman light.", sub: "Real moments from evenings on the rooftop. Tap an image to enlarge.", close: "Close", prev: "Previous", next: "Next" },
    testimonials: {
      overline: "Guests", shareTitle: "Did you dine on the rooftop?", shareSub: "Leave a review, you'll help spread the word about the project.", shareCta: "Leave a review", orGoogle: "or on Google", shareSection: "Have you been a guest?",
      emptyTitle: "The voices of our first guests\nwill appear here.",
      emptySub: "Eternal City View has just opened the terrace doors. If you've dined here, your review will be the first read by those discovering the project.",
      emptyCta: "Be the first to share it",
    },
    reviews: { overline: "Reviews", formTitle: "Your review", formSub: "I'll publish your review after a quick check. Thank you — word of mouth is the most precious thing for someone doing this work.", rating: "Rating", name: "Name", namePh: "E.g. Marco R.", origin: "City", originPh: "E.g. Rome, Boston…", text: "Your experience", textPh: "What stayed with you from the evening? Recipe, atmosphere, view, anything…", submit: "Send review", sending: "Sending…", cancel: "Cancel", success: "Thank you! I'll publish your review after a quick check.", error: "Something went wrong. Please retry.", errorRating: "Pick a rating from 1 to 5 stars.", errorQuote: "Write at least ten characters." },
    booking: {
      overline: "Booking", title: "Pick your evening.", sub: "Only one booking per day so you get my full attention. Lock your date now with a €50 deposit — instant confirmation.",
      name: "Full name", email: "Email", phone: "Phone (WhatsApp)",
      classType: "Which package", coppie: "Couples · Romantic", gruppo: "Small group", tartufo: "Truffle & Champagne", degustazione: "Tasting Dinner", evento: "Private/corporate event",
      date: "Preferred date", pickDate: "Pick a date", invalidEmail: "Invalid email address — please check and try again", slot: "Preferred time", slotHint: "E.g. 1:00 PM for lunch, 7:30 PM for dinner — we'll fine-tune it together.",
      guests: "Number of guests", message: "Message (allergies, occasion, notes)",
      submit: "Send request", sending: "Sending…", success: "Request sent! I'll reply within 24 hours.", error: "Something went wrong. Please retry.",
      confirmedTitle: "Request received!", confirmedSub: "Thank you. I'll reply personally within 24 hours via email or WhatsApp to confirm availability and details.",
      depositTitle: "Want to lock your date now?", depositSub: "To confirm the booking and reserve the terrace just for you, you can pay the deposit securely via Stripe.", depositCta: "Pay the deposit", depositSecure: "Secure payment via Stripe", newBooking: "Send another request",
      payButton: "Continue to payment", payAmount: "Deposit €50", payHint: "You will be redirected to Stripe to complete the payment securely.",
      paidTitle: "Booking confirmed!", paidSub: "Your deposit is in and the date is officially locked on the rooftop. You'll receive the exact address and all the details by email 48 hours before the experience.",
      cancelTitle: "Payment cancelled",
      cancelSub: "You were not charged. Your request is still pending: you can finish payment later or reach out on WhatsApp.",
      retry: "Retry payment", backHome: "Back to home", checkingPayment: "Checking payment…",
    },
    faq: {
      overline: "Frequently asked", title: "Before you book.",
      items: [
        { q: "Where is the terrace?", a: "In the heart of the historic center, just steps from Piazza di Spagna. I send the exact address on confirmation." },
        { q: "What's included?", a: "Aperitivo, all ingredients, Castelli wine, water and coffee. No hidden cost." },
        { q: "Vegetarian / allergies?", a: "Absolutely. Write it in the message — I'm a chef, it's never a problem." },
        { q: "What if it rains?", a: "The terrace has a covered area. In serious weather we move into the kitchen, which is part of the experience anyway." },
        { q: "How do I pay?", a: "At confirmation I ask a small deposit via bank transfer or PayPal. The balance on the evening, cash or card." },
        { q: "Minimum guests?", a: "From 2 guests up. Max 6 for the cooking class, 8 for the tasting." },
      ],
    },
    google: { overline: "Google Reviews", basedOn: "Based on {{n}} verified reviews", verifiedOnGoogle: "Verified on Google", writeReview: "Write a review" },
    footer: { tagline: "Private cooking experiences · Piazza di Spagna, Rome", rights: "All rights reserved.", contacts: "Contact", cookiePolicy: "Cookie Policy", cookieSettings: "Cookie settings" },
    cookies: {
      bannerTitle: "We use cookies",
      bannerBody: "We use necessary cookies to make the site work and, with your consent, analytics cookies to understand how it's used. No advertising or profiling cookies.",
      readPolicy: "Read the Cookie Policy",
      acceptAll: "Accept all",
      rejectAll: "Reject",
      customize: "Customize",
      prefsOverline: "Preferences",
      prefsTitle: "Manage cookies",
      prefsSub: "Choose which cookies to allow. You can change your mind anytime from the link in the footer.",
      necessaryTitle: "Necessary cookies",
      necessaryDesc: "Essential for the site to work (language, preferences, secure payments). No consent required.",
      analyticsTitle: "Analytics cookies",
      analyticsDesc: "Google Analytics and PostHog to anonymously measure how the site is used and improve it. IP anonymised.",
      alwaysActive: "Always on",
      savePrefs: "Save preferences",
    },
    cookiePolicy: {
      overline: "Legal",
      title: "Cookie Policy",
      lastUpdated: "Last updated",
      updateDate: "February 2026",
      back: "Back to home",
      intro: "This Cookie Policy explains what cookies and similar technologies are used by eternalcityview.com (the \"Site\"), operated by Alessandro Pivano. The Site is designed to respect your privacy: no non-essential cookies are installed without your explicit consent.",
      whatAreTitle: "What are cookies",
      whatAreBody: "Cookies are small text files that visited sites send to your device, where they are stored to be sent back to the same sites on your next visit. We also use similar technologies (localStorage) to store your preferences.",
      typesTitle: "Types of cookies used",
      necessaryTitle: "Technical cookies (necessary)",
      necessaryBody: "Required for the Site to work, to store your selected language and to process payments securely via Stripe. No consent required under EU/GDPR rules.",
      analyticsTitle: "Analytics cookies (optional)",
      analyticsBody: "We use Google Analytics 4 and PostHog to collect aggregated and anonymous information about how visitors use the Site (pages viewed, session duration, device, referral). IP addresses are anonymised. These cookies are only installed with your consent.",
      tableTitle: "Cookies used on the Site",
      thName: "Name",
      thProvider: "Provider",
      thPurpose: "Purpose",
      thDuration: "Duration",
      rowGaPurpose: "Aggregated and anonymous usage statistics (analytics)",
      rowPhPurpose: "Product analytics and anonymised session replay",
      rowConsentPurpose: "Stores your cookie preferences",
      rowLangPurpose: "Stores the language you selected",
      rowStripePurpose: "Secure payment processing (deposit)",
      duration2y: "2 years",
      duration1y: "1 year",
      duration6m: "6 months",
      durationPersistent: "Persistent",
      manageTitle: "How to manage consent",
      manageBody: "You can change or withdraw your preferences at any time by clicking the button below.",
      manageCta: "Manage cookie preferences",
      browserNote: "You can also block or delete cookies directly in your browser settings (Chrome, Safari, Firefox, Edge, etc.). Please note that disabling technical cookies may impact the correct functioning of the Site.",
      rightsTitle: "Your rights (GDPR)",
      rightsBody: "Under Regulation (EU) 2016/679 (GDPR), you have the right to access, rectify, erase, restrict and port your personal data, as well as the right to object and to lodge a complaint with the Italian Data Protection Authority.",
      contactTitle: "Contact",
      contactBody: "For any question about this Cookie Policy or the processing of your data, please write to",
    },
    floating: { question: "Quick question?", sub: "Send me a WhatsApp, I reply personally.", cta: "Open WhatsApp", greeting: "Hi Alessandro, I'd like information about your cooking experiences on the rooftop.", emailSub: "Prefer email? Drop me a line, I reply within a few hours.", emailCta: "Open Email", emailSubject: "Rooftop cooking experience inquiry", emailBody: "Hi Alessandro,\n\nI'd like some information about your cooking experiences on the rooftop.\n\nThanks," },
    admin: {
      addReview: "+ Add review", cancel: "Cancel", publish: "Publish", addReviewValidation: "Please fill name, city and quote (min 10 chars).", addReviewSuccess: "Review published", reviewLanguage: "Language",
      gallery: "Gallery", uploadPhotos: "Upload photos", noPhotos: "No photos yet.",
      availability: "Availability",
      activeWeekdays: "Active weekdays", timeRange: "Time range", maxPerDay: "Max events per day", saveConfig: "Save configuration", configSaved: "Configuration saved",
      weekdays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      blockedDates: "Blocked dates", addBlockedDate: "Add date", blockedReason: "Reason (optional)", noBlockedDates: "No blocked dates.", blockedRemove: "Remove",
      calendarView: "Calendar", listView: "List",
      editBooking: "Edit booking", refundBooking: "Refund & cancel", refundConfirm: "Refund €50 and cancel this booking?", refundSuccess: "Refund processed", saveChanges: "Save changes", changesSaved: "Changes saved",
      bookingDetails: "Booking details", noBookingOnDate: "No booking on this date.",
      title: "Admin", loginTitle: "Sign in", password: "Password", login: "Enter", logout: "Sign out",
      bookings: "Bookings", reviewsTitle: "Reviews", noBookings: "No bookings yet.", noReviews: "No reviews yet.", wrongPassword: "Wrong password.",
      columns: { date: "Date", slot: "Time", class: "Experience", guests: "Guests", name: "Name", contact: "Contact", message: "Notes", received: "Received", status: "Status", actions: "Actions" },
      reviewColumns: { rating: "Rating", name: "Name", origin: "City", quote: "Text", received: "Received", status: "Status", actions: "Actions" },
      statuses: { pending: "Pending", abandoned: "Abandoned", expired: "Expired", pending_payment: "Awaiting payment", failed: "Failed", confirmed: "Confirmed", cancelled: "Cancelled", approved: "Approved", rejected: "Rejected" },
      confirm: "Confirm", cancel: "Cancel", delete: "Delete", approve: "Approve", reject: "Reject", all: "All",
    },
  },

  fr: {
    nav: { classes: "Expériences", about: "Le Chef", experience: "La Soirée", gallery: "Galerie", testimonials: "Invités", book: "Réserver", admin: "Admin" },
    hero: { overline: "Cooking experience privée · Place d'Espagne", title: "Rome éternelle,\ndepuis ma terrasse.", sub: "Une expérience culinaire intime au-dessus des toits du centre historique. Apéritif au coucher du soleil, pâtes fraîches avec le chef, tiramisù et dégustation de ce que vous avez créé.", cta: "Réserver une soirée", ctaGhost: "Découvrir les expériences" },
    ribbon: "Pâtes fraîches faites main · Vue sur la Place d'Espagne · Recettes romaines · Tiramisù d'auteur · Invités, pas clients",
    classes: {
      overline: "Les Formules", title: "Trois expériences pour vivre\nRome depuis la terrasse.",
      coppie: { title: "Couples · Romantique", persons: "2 personnes", price: "170 € / personne", desc: "Cooking class privée de pâtes fraîches et tiramisù, dégustation sur la terrasse au coucher du soleil avec vue sur les toits du centre historique. Vins locaux inclus.", cta: "Réserver" },
      gruppo: { title: "Petit Groupe", persons: "4–8 personnes", price: "150 € / personne", desc: "La même expérience en format convivial, idéale pour les familles ou les groupes d'amis en voyage. Vins locaux inclus.", cta: "Réserver" },
      tartufo: { title: "Truffe & Champagne", persons: "2–6 personnes", price: "250 € / personne", desc: "Expérience signature avec dégustation de truffe fraîche, champagne en accord, cooking class de pâtes fraîches et tiramisù, dégustation sur la terrasse au coucher du soleil.", cta: "Réserver", badge: "Premium" },
      degustazione: { title: "Dîner Dégustation", persons: "2–8 personnes", price: "150 € / personne", desc: "Dîner dégustation signé par le chef sur la terrasse au coucher du soleil : antipasti, pâtes fraîches, plat principal romain, tiramisù. Détendez-vous et profitez de la vue — on cuisine pour vous.", cta: "Réserver" },
      evento: { title: "Événement Privé / Corporate", persons: "Sur demande", price: "Sur demande", desc: "Expérience sur mesure pour team building, célébrations, enterrements de vie de garçon ou de jeune fille.", cta: "WhatsApp" },
      note: "Menu et sélection de vins personnalisables selon vos préférences et besoins (allergies, intolérances, demandes spéciales). Contactez-nous pour construire votre expérience sur mesure.",
      buildEvening: {
      navLink: "Build your evening",
      heroOverline: "Build your evening",
      heroTitle: "Composez votre soirée",
      heroSub: "Choisissez l'expérience, le menu et les vins. Acompte 50 € en ligne, solde le soir sur la terrasse.",
      step1Title: "Votre expérience",
      step2Title: "Votre menu",
      step3Title: "Vos vins",
      step4Title: "Vos coordonnées",
      guestsLabel: "Invités",
      dateLabel: "Date",
      timeLabel: "Heure",
      perPerson: "/ personne",
      perBottle: "/ bouteille",
      bottlesLabel: "bouteilles",
      bottleLabel: "bouteille",
      guestsSuffix: "invités",
      wineNote: "Les vins se règlent le soir directement à la terrasse.",
      experiences: {
        coppie: { title: "Couples · Romantique", persons: "2 invités", desc: "Soirée privée pour deux au coucher du soleil." },
        gruppo: { title: "Petit Groupe", persons: "4–8 invités", desc: "Format convivial pour familles ou amis en voyage." },
      },
      menus: {
        tradizione: { name: "Tradition Romaine", desc: "Antipasti romains, pâtes fraîches (cacio e pepe ou amatriciana), tiramisù, café et limoncello maison." },
        pesce: { name: "Dégustation Poisson", desc: "Antipasti de la mer, pâtes fraîches aux fruits de mer, dessert du chef, café et limoncello maison." },
        tartufo: { name: "Truffe Blanche", desc: "Antipasti à la truffe, tagliolini à la truffe blanche fraîche, tiramisù, café et limoncello maison." },
      },
      wineCategories: { white: "Blancs", red: "Rouges", rose: "Rosés", sparkling: "Pétillants", champagne: "Champagne" },
      summaryTitle: "Votre soirée",
      experienceRow: "Expérience",
      menuRow: "Menu",
      winesRow: "Vins",
      totalLabel: "Total",
      depositLabel: "Acompte maintenant (Stripe)",
      balanceLabel: "Solde le soir",
      formTitle: "Qui êtes-vous ?",
      nameLabel: "Nom et prénom",
      emailLabel: "E-mail",
      phoneLabel: "Téléphone (WhatsApp)",
      notesLabel: "Notes (allergies, intolérances, célébrations)",
      bookNow: "Réserver avec acompte 50 €",
      bookingSuccess: "Parfait ! Vous allez être redirigé vers le paiement sécurisé…",
      bookingError: "Une erreur est survenue. Réessayez ou écrivez-nous sur WhatsApp.",
      selectRequired: "Choisissez une expérience, un menu et une date pour continuer.",
      noWines: "Aucun vin sélectionné (vous pouvez aussi apporter le vôtre).",
      removeWine: "Retirer",
    },
    terraceTitle: "La terrasse",
      terraceSub: "À deux pas de la Place d'Espagne, entre clochers et toits du XVIIe siècle.",
      detailsCta: "En savoir plus",
    },
    experiences: {
      backToAll: "← Toutes les expériences",
      backHome: "← Retour à l'accueil",
      durationLabel: "Durée",
      guestsLabel: "Invités",
      priceLabel: "Prix",
      includesTitle: "Ce qui est inclus",
      flowTitle: "Comment se déroule la soirée",
      whyTitle: "Pourquoi choisir cette expérience",
      bookNow: "Réserver cette expérience",
      otherTitle: "Autres expériences sur la terrasse",
      badgePremium: "Premium",
      pageTitleSuffix: " · Eternal City View",
      coppie: {
        metaTitle: "Cooking Class Romantique à Rome pour Couples",
        metaDescription: "Soirée privée sur la terrasse de la Place d'Espagne pour deux : pâtes fraîches à quatre mains, tiramisù, apéritif au coucher du soleil et dîner avec vue sur les toits de Rome.",
        heroTagline: "Rien que vous deux, le coucher de soleil et Rome sous la terrasse.",
        descLong: "Une soirée conçue pour les couples : cooking class privée avec le chef Alessandro, apéritif au coucher du soleil et dîner aux chandelles sur la terrasse avec vue panoramique sur les toits du centre historique. Parfait pour anniversaires, demandes en mariage, lunes de miel ou simplement une soirée inoubliable à Rome.",
        duration: "≈ 3 heures",
        includes: [
          "Cooking class privée de pâtes fraîches à quatre mains",
          "Préparation du tiramisù de la maison",
          "Apéritif au coucher du soleil avec un verre d'accueil",
          "Dîner complet avec vin des Castelli, eau et café",
          "Vue panoramique exclusive sur les toits de Rome",
        ],
        flow: [
          "Accueil sur la terrasse au coucher du soleil",
          "Cooking class : pâte, pâtes fraîches et tiramisù",
          "Dîner romantique avec les plats préparés ensemble",
          "Café, digestif et longues discussions sous les étoiles",
        ],
        why: [
          "Vie privée totale — rien que vous deux",
          "Personnalisable pour anniversaires ou demandes",
          "Menu adapté aux allergies et préférences",
        ],
      },
      gruppo: {
        metaTitle: "Cooking Class en Petit Groupe à Rome · Terrasse Place d'Espagne",
        metaDescription: "Expérience culinaire conviviale pour 4-8 personnes sur la terrasse au cœur de Rome : pâtes fraîches faites main, tiramisù et dîner au coucher du soleil.",
        heroTagline: "Votre tribu, la terrasse de Rome, une soirée unique.",
        descLong: "L'expérience parfaite pour familles, amis en voyage ou petits groupes qui veulent partager quelque chose de vraiment spécial. Cooking class conviviale avec le chef Alessandro sur la terrasse près de la Place d'Espagne, apéritif au coucher du soleil et dîner avec les plats préparés ensemble.",
        duration: "≈ 3 heures",
        includes: [
          "Cooking class de groupe de pâtes fraîches à la main",
          "Préparation du tiramisù du chef",
          "Apéritif au coucher du soleil avec amuse-bouches",
          "Dîner complet avec vin des Castelli, eau et café",
          "Vue panoramique sur les toits du centre historique",
        ],
        flow: [
          "Accueil sur la terrasse avec apéritif",
          "Cooking class conviviale à plusieurs mains",
          "Dîner de groupe avec les plats préparés",
          "Café, discussions et digestif final",
        ],
        why: [
          "Format convivial idéal pour groupes d'amis",
          "Adapté aux enfants (menu sur mesure)",
          "Un souvenir de Rome à ramener ensemble",
        ],
      },
      tartufo: {
        metaTitle: "Expérience Truffe & Champagne à Rome · Cooking Class Premium",
        metaDescription: "Expérience signature sur la terrasse de la Place d'Espagne : dégustation de truffe fraîche, champagne en accord, cooking class de pâtes fraîches et dîner au coucher du soleil.",
        heroTagline: "Truffe fraîche, champagne et les toits de Rome au coucher du soleil.",
        descLong: "L'expérience premium signée Eternal City View : dégustation guidée de truffe fraîche, champagne en accord, cooking class de pâtes fraîches à la truffe et dîner exclusif sur la terrasse avec vue panoramique. Un événement sur mesure pour palais raffinés ou occasions vraiment spéciales.",
        duration: "≈ 3,5 heures",
        includes: [
          "Dégustation guidée de truffe fraîche",
          "Verre de champagne en accord",
          "Cooking class privée de pâtes fraîches à la truffe",
          "Tiramisù de la maison et dîner complet",
          "Vins sélectionnés, eau et café",
          "Vue panoramique exclusive sur Rome",
        ],
        flow: [
          "Apéritif au champagne au coucher du soleil",
          "Dégustation guidée de truffe fraîche",
          "Cooking class de pâtes fraîches à la truffe",
          "Dîner signature avec accords vins",
          "Digestif, dessert et longs adieux",
        ],
        why: [
          "Une expérience gourmande unique à Rome",
          "Ingrédients premium sélectionnés par le chef",
          "Parfait pour les occasions à célébrer",
        ],
      },
      degustazione: {
        metaTitle: "Dîner Dégustation sur la Terrasse · Place d'Espagne, Rome",
        metaDescription: "Dîner dégustation signé par le chef sur la terrasse de la Place d'Espagne : antipasti, pâtes fraîches, plat romain, tiramisù. Détendez-vous — on cuisine pour vous.",
        heroTagline: "Asseyez-vous, trinquez et laissez faire le chef.",
        descLong: "Pas de cooking class cette fois : juste vous, vos invités et la cuisine du chef. Un dîner dégustation complet à plusieurs plats sur la terrasse au coucher du soleil, avec un menu conçu par Alessandro. Parfait pour ceux qui veulent profiter de Rome sans souci, avec le soin d'une table de famille et la précision d'un chef.",
        duration: "≈ 2,5 heures",
        includes: [
          "Antipasti du chef",
          "Plat principal de pâtes fraîches faites main",
          "Second plat de la tradition romaine",
          "Tiramisù de la maison",
          "Vin des Castelli, eau et café",
          "Service à table sur la terrasse",
        ],
        flow: [
          "Apéritif de bienvenue au coucher du soleil",
          "Antipasti du chef",
          "Plat principal et second plat servis à table",
          "Dessert, café et digestif final",
        ],
        why: [
          "Idéal pour ceux qui veulent seulement le dîner (sans cooking class)",
          "Menu saisonnier créé par le chef",
          "Rythme détendu, vue panoramique",
        ],
      },
    },
    about: { overline: "Le Chef", title: "Je suis Alessandro.\nBienvenue sur ma terrasse.", body: "Je cuisine depuis tout petit, dans le restaurant de ma mère — cuisine romaine traditionnelle, sans compromis. Je suis diplômé de l'Italian Chef Academy et j'ai fait mon chemin entre traiteurs et cuisines d'auteur.\n\nAujourd'hui j'ai décidé d'apporter tout cela chez moi, sur la terrasse à deux pas de la Place d'Espagne. Plus de salles bondées : juste vous, vos invités, les toits de Rome et un dîner cuisiné comme en famille — mais avec la main d'un chef.", signature: "— Alessandro Pivano" },
    experience: {
      seo: "Vous cherchez un cooking class privé à Rome près de la Place d'Espagne ? Eternal City View propose une expérience intime sur la terrasse à quelques pas de Piazza di Spagna — pâtes faites main, recettes de la cuisine romaine et un dîner au coucher du soleil avec vue panoramique sur le centre historique. Contrairement aux grandes écoles de cuisine pour groupes, il s'agit d'une soirée privée, animée par le chef, pour couples, familles et petits groupes en visite à Rome.",
      overline: "La Soirée", title: "Pas un restaurant.\nUne soirée chez moi.",
      items: [
        { tag: "01", title: "Apéritif", text: "Je vous accueille sur la terrasse avec un verre et quelques bouchées, pendant que le soleil se couche sur la Place d'Espagne." },
        { tag: "02", title: "On cuisine ensemble", text: "Pour la cooking class : un type de pâtes fraîches à quatre mains, puis le tiramisù. Techniques de chef, rythme familial." },
        { tag: "03", title: "À table", text: "On dîne avec les plats que vous avez créés (ou ceux signés du chef), accompagnés de vin des Castelli et de pain chaud." },
        { tag: "04", title: "Au revoir long", text: "Café, peut-être un digestif, et de longues discussions pour clôturer la soirée comme il se doit." },
      ],
    },
    gallery: { overline: "Galerie", title: "La terrasse, les assiettes,\nla lumière romaine.", sub: "Moments authentiques des soirées sur la terrasse. Touchez une image pour l'agrandir.", close: "Fermer", prev: "Précédent", next: "Suivant" },
    testimonials: {
      overline: "Les Invités", shareTitle: "Vous avez dîné sur la terrasse ?", shareSub: "Laissez un avis, vous m'aiderez à faire connaître le projet.", shareCta: "Laisser un avis", orGoogle: "ou sur Google", shareSection: "Vous avez été invité ?",
      emptyTitle: "Les voix des premiers invités\napparaîtront ici.",
      emptySub: "Eternal City View vient d'ouvrir les portes de la terrasse. Si vous y avez dîné, votre avis sera le premier lu par ceux qui découvrent le projet.",
      emptyCta: "Soyez le premier à raconter",
    },
    reviews: { overline: "Avis", formTitle: "Votre avis", formSub: "Je publierai votre avis après une rapide vérification. Merci de tout cœur — le bouche-à-oreille est ce qu'il y a de plus précieux pour ce métier.", rating: "Note", name: "Nom", namePh: "Ex. Marco R.", origin: "Ville", originPh: "Ex. Rome, Boston…", text: "Votre expérience", textPh: "Que retenez-vous de la soirée ? Recette, ambiance, vue, n'importe quoi…", submit: "Envoyer l'avis", sending: "Envoi…", cancel: "Annuler", success: "Merci ! Je publierai votre avis après une rapide vérification.", error: "Une erreur s'est produite. Réessayez.", errorRating: "Choisissez une note de 1 à 5 étoiles.", errorQuote: "Écrivez au moins une dizaine de caractères." },
    booking: {
      overline: "Réservation", title: "Choisissez votre soirée.", sub: "Une seule réservation par jour pour vous consacrer toute mon attention. Bloquez votre date maintenant avec un acompte de 50 € — confirmation immédiate.",
      name: "Nom complet", email: "Email", phone: "Téléphone (WhatsApp)",
      classType: "Quelle formule", coppie: "Couples · Romantique", gruppo: "Petit groupe", tartufo: "Truffe & Champagne", degustazione: "Dîner Dégustation", evento: "Événement privé/corporate",
      date: "Date préférée", pickDate: "Choisir une date", invalidEmail: "Adresse e-mail invalide — vérifiez et réessayez", slot: "Horaire préféré", slotHint: "Ex. 13h00 pour le déjeuner, 19h30 pour le dîner — on en discute ensemble.",
      guests: "Nombre d'invités", message: "Message (allergies, occasions, notes)",
      submit: "Envoyer la demande", sending: "Envoi…", success: "Demande envoyée ! Je vous réponds sous 24 heures.", error: "Une erreur s'est produite. Réessayez.",
      confirmedTitle: "Demande reçue !", confirmedSub: "Merci. Je vous réponds personnellement sous 24 heures par email ou WhatsApp pour confirmer la disponibilité et les détails.",
      depositTitle: "Voulez-vous bloquer la date maintenant ?", depositSub: "Pour confirmer la réservation et garder la terrasse pour vous, vous pouvez verser l'acompte de manière sécurisée via Stripe.", depositCta: "Payer l'acompte", depositSecure: "Paiement sécurisé via Stripe", newBooking: "Nouvelle demande",
      payButton: "Passer au paiement", payAmount: "Acompte 50 €", payHint: "Vous serez redirigé vers Stripe pour finaliser le paiement en toute sécurité.",
      paidTitle: "Réservation confirmée !", paidSub: "Votre acompte est enregistré et la date est officiellement bloquée sur la terrasse. Vous recevrez l'adresse exacte et tous les détails par email 48 heures avant l'expérience.",
      cancelTitle: "Paiement annulé",
      cancelSub: "Aucun montant n'a été débité. Votre demande reste en attente : vous pouvez finaliser le paiement plus tard ou nous contacter sur WhatsApp.",
      retry: "Réessayer le paiement", backHome: "Retour à l'accueil", checkingPayment: "Vérification du paiement…",
    },
    faq: {
      overline: "Questions fréquentes", title: "Avant de réserver.",
      items: [
        { q: "Où se trouve la terrasse ?", a: "Au cœur du centre historique, à deux pas de la Place d'Espagne. Je vous envoie l'adresse exacte à la confirmation." },
        { q: "Qu'est-ce qui est inclus ?", a: "Apéritif, tous les ingrédients, vin des Castelli, eau et café. Aucun coût caché." },
        { q: "Végétariens / allergies ?", a: "Absolument. Écrivez-le dans le message et j'adapte le menu — je suis chef, ce n'est jamais un problème." },
        { q: "S'il pleut ?", a: "La terrasse a une zone couverte. En cas de vrai mauvais temps, on déplace tout dans la cuisine, qui fait partie de l'expérience." },
        { q: "Comment payer ?", a: "À la confirmation, je demande un petit acompte par virement ou PayPal. Le solde le soir même, en espèces ou par carte." },
        { q: "Combien minimum ?", a: "À partir de 2 invités. Maximum 6 pour le cooking class, 8 pour la dégustation." },
      ],
    },
    google: { overline: "Avis Google", basedOn: "Basé sur {{n}} avis vérifiés", verifiedOnGoogle: "Vérifié sur Google", writeReview: "Écrire un avis" },
    footer: { tagline: "Cooking experiences privées · Place d'Espagne, Rome", rights: "Tous droits réservés.", contacts: "Contact", cookiePolicy: "Politique cookies", cookieSettings: "Préférences cookies" },
    cookies: {
      bannerTitle: "Nous utilisons des cookies",
      bannerBody: "Nous utilisons des cookies nécessaires au fonctionnement du site et, avec votre accord, des cookies analytiques pour comprendre son utilisation. Aucun cookie publicitaire.",
      readPolicy: "Lire la politique cookies",
      acceptAll: "Tout accepter",
      rejectAll: "Refuser",
      customize: "Personnaliser",
      prefsOverline: "Préférences",
      prefsTitle: "Gérer les cookies",
      prefsSub: "Choisissez les cookies que vous autorisez. Vous pouvez changer d'avis à tout moment depuis le lien en bas de page.",
      necessaryTitle: "Cookies nécessaires",
      necessaryDesc: "Indispensables au fonctionnement du site (langue, préférences, paiements sécurisés). Ne requièrent pas de consentement.",
      analyticsTitle: "Cookies analytiques",
      analyticsDesc: "Google Analytics et PostHog pour mesurer de manière anonyme l'utilisation du site et l'améliorer. IP anonymisée.",
      alwaysActive: "Toujours actifs",
      savePrefs: "Enregistrer",
    },
    cookiePolicy: {
      overline: "Mentions légales",
      title: "Politique cookies",
      lastUpdated: "Dernière mise à jour",
      updateDate: "Février 2026",
      back: "Retour à l'accueil",
      intro: "Cette politique cookies explique quels cookies et technologies similaires sont utilisés par eternalcityview.com (le « Site »), exploité par Alessandro Pivano. Le Site est conçu pour respecter votre vie privée : aucun cookie non essentiel n'est installé sans votre consentement explicite.",
      whatAreTitle: "Que sont les cookies",
      whatAreBody: "Les cookies sont de petits fichiers texte que les sites visités envoient à votre appareil, où ils sont stockés pour être renvoyés à ces mêmes sites lors de votre prochaine visite. Nous utilisons également des technologies similaires (localStorage) pour mémoriser vos préférences.",
      typesTitle: "Types de cookies utilisés",
      necessaryTitle: "Cookies techniques (nécessaires)",
      necessaryBody: "Nécessaires au fonctionnement du Site, à la mémorisation de la langue choisie et au traitement sécurisé des paiements via Stripe. Ne nécessitent pas de consentement selon le RGPD.",
      analyticsTitle: "Cookies analytiques (facultatifs)",
      analyticsBody: "Nous utilisons Google Analytics 4 et PostHog pour collecter des informations agrégées et anonymes sur l'utilisation du Site (pages vues, durée des sessions, appareil, provenance). L'IP est anonymisée. Ces cookies ne sont installés qu'avec votre consentement.",
      tableTitle: "Cookies utilisés sur le Site",
      thName: "Nom",
      thProvider: "Fournisseur",
      thPurpose: "Finalité",
      thDuration: "Durée",
      rowGaPurpose: "Statistiques d'utilisation agrégées et anonymes",
      rowPhPurpose: "Analytique produit et session replay anonymisé",
      rowConsentPurpose: "Mémorise vos préférences cookies",
      rowLangPurpose: "Mémorise la langue sélectionnée",
      rowStripePurpose: "Traitement sécurisé du paiement (acompte)",
      duration2y: "2 ans",
      duration1y: "1 an",
      duration6m: "6 mois",
      durationPersistent: "Persistant",
      manageTitle: "Comment gérer le consentement",
      manageBody: "Vous pouvez modifier ou retirer votre consentement à tout moment en cliquant sur le bouton ci-dessous.",
      manageCta: "Gérer les préférences cookies",
      browserNote: "Vous pouvez également bloquer ou supprimer les cookies directement depuis les paramètres de votre navigateur (Chrome, Safari, Firefox, Edge, etc.). Désactiver les cookies techniques peut nuire au bon fonctionnement du Site.",
      rightsTitle: "Vos droits (RGPD)",
      rightsBody: "Conformément au Règlement UE 2016/679 (RGPD), vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation et de portabilité de vos données personnelles, ainsi que d'un droit d'opposition et de réclamation auprès de l'autorité de contrôle.",
      contactTitle: "Contact",
      contactBody: "Pour toute question relative à cette politique cookies ou au traitement de vos données, écrivez-nous à",
    },
    floating: { question: "Une question rapide ?", sub: "Écrivez-moi sur WhatsApp, je réponds personnellement.", cta: "Ouvrir WhatsApp", greeting: "Bonjour Alessandro, j'aimerais des informations sur les cours de cuisine sur la terrasse.", emailSub: "Vous préférez l'email ? Écrivez-moi, je réponds sous quelques heures.", emailCta: "Ouvrir Email", emailSubject: "Demande d'infos cours de cuisine sur la terrasse", emailBody: "Bonjour Alessandro,\n\nj'aimerais des informations sur les cours de cuisine sur la terrasse.\n\nMerci," },
    admin: {
      addReview: "+ Ajouter un avis", cancel: "Annuler", publish: "Publier", addReviewValidation: "Remplissez nom, ville et texte (min 10 car.).", addReviewSuccess: "Avis publié", reviewLanguage: "Langue",
      gallery: "Galerie", uploadPhotos: "Charger des photos", noPhotos: "Aucune photo pour le moment.",
      title: "Admin", loginTitle: "Connexion", password: "Mot de passe", login: "Entrer", logout: "Déconnexion",
      bookings: "Réservations", reviewsTitle: "Avis", noBookings: "Aucune réservation.", noReviews: "Aucun avis.", wrongPassword: "Mot de passe invalide.",
      columns: { date: "Date", slot: "Horaire", class: "Expérience", guests: "Invités", name: "Nom", contact: "Contact", message: "Notes", received: "Reçue", status: "Statut", actions: "Actions" },
      reviewColumns: { rating: "Note", name: "Nom", origin: "Ville", quote: "Texte", received: "Reçue", status: "Statut", actions: "Actions" },
      statuses: { pending: "En attente", abandoned: "Abandonnée", expired: "Expirée", pending_payment: "Paiement en attente", failed: "Échouée", confirmed: "Confirmée", cancelled: "Annulée", approved: "Approuvé", rejected: "Rejeté" },
      confirm: "Confirmer", cancel: "Annuler", delete: "Supprimer", approve: "Approuver", reject: "Rejeter", all: "Toutes",
    },
  },

  es: {
    nav: { classes: "Experiencias", about: "El Chef", experience: "La Velada", gallery: "Galería", testimonials: "Huéspedes", book: "Reservar", admin: "Admin" },
    hero: { overline: "Cooking experience privada · Plaza de España", title: "Roma eterna,\ndesde mi terraza.", sub: "Una experiencia culinaria íntima sobre los tejados del centro histórico. Aperitivo al atardecer, pasta fresca con el chef, tiramisú y degustación de lo que has creado.", cta: "Reservar una velada", ctaGhost: "Descubrir las experiencias" },
    ribbon: "Pasta fresca a mano · Vista a la Plaza de España · Recetas romanas · Tiramisú de autor · Huéspedes, no clientes",
    classes: {
      overline: "Los Paquetes", title: "Tres experiencias para vivir\nRoma desde la terraza.",
      coppie: { title: "Parejas · Romántico", persons: "2 personas", price: "170 € / persona", desc: "Cooking class privada de pasta fresca y tiramisú, degustación en la terraza al atardecer con vistas a los tejados del centro histórico. Vinos locales incluidos.", cta: "Reservar" },
      gruppo: { title: "Pequeño Grupo", persons: "4–8 personas", price: "150 € / persona", desc: "La misma experiencia en formato convivial, ideal para familias o grupos de amigos de viaje. Vinos locales incluidos.", cta: "Reservar" },
      tartufo: { title: "Trufa & Champán", persons: "2–6 personas", price: "250 € / persona", desc: "Experiencia signature con degustación de trufa fresca, champán en maridaje, cooking class de pasta fresca y tiramisú, degustación en la terraza al atardecer.", cta: "Reservar", badge: "Premium" },
      degustazione: { title: "Cena Degustación", persons: "2–8 personas", price: "150 € / persona", desc: "Cena de degustación firmada por el chef en la terraza al atardecer: antipasti, plato de pasta fresca, segundo romano, tiramisú. Relájate y disfruta de la vista — cocinamos nosotros para ti.", cta: "Reservar" },
      evento: { title: "Evento Privado / Corporativo", persons: "Bajo petición", price: "Bajo petición", desc: "Experiencia a medida para team building, celebraciones, despedidas de soltero o soltera.", cta: "Escríbenos por WhatsApp" },
      note: "Menú y selección de vinos personalizables según tus preferencias y necesidades (alergias, intolerancias, peticiones especiales). Contáctanos para diseñar tu experiencia a medida.",
      buildEvening: {
      navLink: "Build your evening",
      heroOverline: "Build your evening",
      heroTitle: "Diseña tu velada",
      heroSub: "Elige la experiencia, el menú y los vinos. Depósito 50 € online, el resto la noche en la terraza.",
      step1Title: "Tu experiencia",
      step2Title: "Tu menú",
      step3Title: "Tus vinos",
      step4Title: "Tus datos",
      guestsLabel: "Huéspedes",
      dateLabel: "Fecha",
      timeLabel: "Hora",
      perPerson: "/ persona",
      perBottle: "/ botella",
      bottlesLabel: "botellas",
      bottleLabel: "botella",
      guestsSuffix: "huéspedes",
      wineNote: "Los vinos se pagan la noche directamente en la terraza.",
      experiences: {
        coppie: { title: "Parejas · Romántico", persons: "2 huéspedes", desc: "Velada privada para dos al atardecer." },
        gruppo: { title: "Pequeño Grupo", persons: "4–8 huéspedes", desc: "Formato convivial para familias o amigos de viaje." },
      },
      menus: {
        tradizione: { name: "Tradición Romana", desc: "Antipasti romanos, pasta fresca (cacio e pepe o amatriciana), tiramisú, café y limoncello de la casa." },
        pesce: { name: "Degustación de Pescado", desc: "Antipasti de mar, pasta fresca con mariscos, postre del chef, café y limoncello de la casa." },
        tartufo: { name: "Trufa Blanca", desc: "Antipasti a la trufa, tagliolini a la trufa blanca fresca, tiramisú, café y limoncello de la casa." },
      },
      wineCategories: { white: "Blancos", red: "Tintos", rose: "Rosados", sparkling: "Espumosos", champagne: "Champán" },
      summaryTitle: "Tu velada",
      experienceRow: "Experiencia",
      menuRow: "Menú",
      winesRow: "Vinos",
      totalLabel: "Total",
      depositLabel: "Depósito ahora (Stripe)",
      balanceLabel: "Resto la noche",
      formTitle: "¿Quién eres?",
      nameLabel: "Nombre completo",
      emailLabel: "Email",
      phoneLabel: "Teléfono (WhatsApp)",
      notesLabel: "Notas (alergias, intolerancias, celebraciones)",
      bookNow: "Reservar con depósito 50 €",
      bookingSuccess: "¡Perfecto! Te llevamos al pago seguro…",
      bookingError: "Algo salió mal. Reinténtalo o escríbenos por WhatsApp.",
      selectRequired: "Elige experiencia, menú y fecha para continuar.",
      noWines: "No has elegido vinos (también puedes traer el tuyo).",
      removeWine: "Quitar",
    },
    terraceTitle: "La terraza",
      terraceSub: "A dos pasos de la Plaza de España, entre campanarios y tejados del siglo XVII.",
      detailsCta: "Descubrir más",
    },
    experiences: {
      backToAll: "← Todas las experiencias",
      backHome: "← Volver al inicio",
      durationLabel: "Duración",
      guestsLabel: "Huéspedes",
      priceLabel: "Precio",
      includesTitle: "Qué incluye",
      flowTitle: "Cómo se desarrolla la velada",
      whyTitle: "Por qué elegir esta experiencia",
      bookNow: "Reservar esta experiencia",
      otherTitle: "Otras experiencias en la terraza",
      badgePremium: "Premium",
      pageTitleSuffix: " · Eternal City View",
      coppie: {
        metaTitle: "Cooking Class Romántica en Roma para Parejas",
        metaDescription: "Velada privada en la terraza de la Plaza de España para dos: pasta fresca a cuatro manos, tiramisú, aperitivo al atardecer y cena con vistas a los tejados de Roma.",
        heroTagline: "Solo vosotros dos, el atardecer y Roma bajo la terraza.",
        descLong: "Una velada pensada para parejas: cooking class privada con el chef Alessandro, aperitivo al atardecer y cena a la luz de las velas en la terraza con vistas panorámicas sobre los tejados del centro histórico. Perfecta para aniversarios, pedidas, lunas de miel o simplemente una velada inolvidable en Roma.",
        duration: "≈ 3 horas",
        includes: [
          "Cooking class privada de pasta fresca a cuatro manos",
          "Preparación del tiramisú de la casa",
          "Aperitivo al atardecer con copa de bienvenida",
          "Cena completa con vino de los Castelli, agua y café",
          "Vista panorámica exclusiva sobre los tejados de Roma",
        ],
        flow: [
          "Bienvenida en la terraza con copa al atardecer",
          "Cooking class: masa, pasta y tiramisú",
          "Cena romántica con los platos creados juntos",
          "Café, digestivo y largas despedidas bajo las estrellas",
        ],
        why: [
          "Privacidad total — solo vosotros dos",
          "Personalizable para aniversarios o pedidas",
          "Menú adaptado a alergias y preferencias",
        ],
      },
      gruppo: {
        metaTitle: "Cooking Class en Pequeño Grupo en Roma · Terraza Plaza de España",
        metaDescription: "Experiencia culinaria convivial para 4-8 personas en la terraza en el corazón de Roma: pasta fresca a mano, tiramisú y cena al atardecer con vistas panorámicas.",
        heroTagline: "Vuestra tribu, la terraza de Roma, una velada única.",
        descLong: "La experiencia perfecta para familias, amigos de viaje o pequeños grupos que quieren compartir algo realmente especial. Cooking class convivial con el chef Alessandro en la terraza junto a la Plaza de España, aperitivo al atardecer y cena con los platos preparados juntos.",
        duration: "≈ 3 horas",
        includes: [
          "Cooking class grupal de pasta fresca a mano",
          "Preparación del tiramisú del chef",
          "Aperitivo al atardecer con aperitivos",
          "Cena completa con vino de los Castelli, agua y café",
          "Vista panorámica sobre los tejados del centro histórico",
        ],
        flow: [
          "Bienvenida en la terraza con aperitivo",
          "Cooking class convivial a varias manos",
          "Cena grupal con los platos creados",
          "Café, charla y digestivo final",
        ],
        why: [
          "Formato convivial ideal para grupos de amigos",
          "Apto para niños (menú a medida)",
          "Un recuerdo de Roma para llevar juntos",
        ],
      },
      tartufo: {
        metaTitle: "Experiencia Trufa & Champán en Roma · Cooking Class Premium",
        metaDescription: "Experiencia signature en la terraza de la Plaza de España: degustación de trufa fresca, champán en maridaje, cooking class de pasta fresca y cena al atardecer.",
        heroTagline: "Trufa fresca, champán y los tejados de Roma al atardecer.",
        descLong: "La experiencia premium firmada por Eternal City View: degustación guiada de trufa fresca, champán en maridaje, cooking class de pasta fresca con trufa y cena exclusiva en la terraza con vista panorámica. Un evento a medida para paladares refinados u ocasiones realmente especiales.",
        duration: "≈ 3,5 horas",
        includes: [
          "Degustación guiada de trufa fresca",
          "Copa de champán en maridaje",
          "Cooking class privada de pasta fresca con trufa",
          "Tiramisú de la casa y cena completa",
          "Vinos seleccionados, agua y café",
          "Vista panorámica exclusiva sobre Roma",
        ],
        flow: [
          "Aperitivo con champán al atardecer",
          "Degustación guiada de trufa fresca",
          "Cooking class de pasta fresca con trufa",
          "Cena signature con maridaje de vinos",
          "Digestivo, postre y largas despedidas",
        ],
        why: [
          "Una experiencia gourmet única en Roma",
          "Ingredientes premium seleccionados por el chef",
          "Perfecta para ocasiones celebrativas",
        ],
      },
      degustazione: {
        metaTitle: "Cena Degustación en la Terraza · Plaza de España, Roma",
        metaDescription: "Cena degustación firmada por el chef en la terraza de la Plaza de España: antipasti, pasta fresca, segundo romano, tiramisú. Relájate — cocinamos nosotros.",
        heroTagline: "Sentaos, brindad y dejad que guíe el chef.",
        descLong: "Ninguna cooking class esta vez: solo tú, tus invitados y la cocina del chef. Una cena degustación completa con varios platos en la terraza al atardecer, con menú diseñado por Alessandro. Perfecta para quienes quieren disfrutar de Roma sin preocupaciones, con el cuidado de una mesa familiar y la precisión de un chef.",
        duration: "≈ 2,5 horas",
        includes: [
          "Antipasti del chef",
          "Plato principal de pasta fresca a mano",
          "Segundo de la tradición romana",
          "Tiramisú de la casa",
          "Vino de los Castelli, agua y café",
          "Servicio de mesa en la terraza",
        ],
        flow: [
          "Aperitivo de bienvenida al atardecer",
          "Antipasti del chef",
          "Plato principal y segundo servidos en mesa",
          "Postre, café y digestivo final",
        ],
        why: [
          "Ideal para quien solo quiere la cena (sin cooking class)",
          "Menú de temporada creado por el chef",
          "Ritmo relajado, vista panorámica",
        ],
      },
    },
    about: { overline: "El Chef", title: "Soy Alessandro.\nBienvenido a mi terraza.", body: "Cocino desde que era un niño, en el restaurante de mi madre — cocina romana tradicional, sin atajos. Me gradué en la Italian Chef Academy y he hecho camino entre catering y cocinas de autor.\n\nHoy he decidido traer todo eso a mi casa, en la terraza a dos pasos de la Plaza de España. Sin salas abarrotadas: solo tú, tus invitados, los tejados de Roma y una cena cocinada como en familia — pero con la mano de un chef.", signature: "— Alessandro Pivano" },
    experience: {
      seo: "¿Buscas una cooking class privada en Roma cerca de la Plaza de España? Eternal City View ofrece una experiencia íntima en la terraza a dos pasos de Piazza di Spagna — pasta hecha a mano, recetas de la cocina romana y una cena al atardecer con vistas panorámicas al centro histórico. A diferencia de las grandes escuelas de cocina para grupos, es una velada privada, dirigida por el chef, para parejas, familias y pequeños grupos que visitan Roma.",
      overline: "La Velada", title: "No un restaurante.\nUna noche en mi casa.",
      items: [
        { tag: "01", title: "Aperitivo", text: "Te recibo en la terraza con una copa y algunos bocados, mientras el sol se pone sobre la Plaza de España." },
        { tag: "02", title: "Cocinamos juntos", text: "Para la cooking class: un tipo de pasta fresca a cuatro manos, después el tiramisú. Técnicas de chef, ritmo de casa." },
        { tag: "03", title: "A la mesa", text: "Cenamos con los platos que has creado (o los firmados por el chef), acompañados de vino de los Castelli y pan caliente." },
        { tag: "04", title: "Despedidas largas", text: "Café, quizás un digestivo, y una larga charla para cerrar la velada como se debe." },
      ],
    },
    gallery: { overline: "Galería", title: "La terraza, los platos,\nla luz de Roma.", sub: "Momentos reales de las veladas en la terraza. Toca una imagen para ampliarla.", close: "Cerrar", prev: "Anterior", next: "Siguiente" },
    testimonials: {
      overline: "Los Huéspedes", shareTitle: "¿Has cenado en la terraza?", shareSub: "Deja una reseña, me ayudarás a dar a conocer el proyecto.", shareCta: "Dejar una reseña", orGoogle: "o en Google", shareSection: "¿Has sido huésped?",
      emptyTitle: "Las voces de los primeros huéspedes\napareceran aquí.",
      emptySub: "Eternal City View acaba de abrir las puertas de la terraza. Si has cenado aquí, tu reseña será la primera que lean quienes descubren el proyecto.",
      emptyCta: "Sé el primero en contarla",
    },
    reviews: { overline: "Reseñas", formTitle: "Tu reseña", formSub: "Publicaré tu reseña tras una breve revisión. Mil gracias — el boca a boca es lo más valioso para quien hace este oficio.", rating: "Valoración", name: "Nombre", namePh: "Ej. Marco R.", origin: "Ciudad", originPh: "Ej. Roma, Boston…", text: "Tu experiencia", textPh: "¿Qué te llevas de la velada? Receta, ambiente, vista, lo que sea…", submit: "Enviar reseña", sending: "Enviando…", cancel: "Cancelar", success: "¡Gracias! Publicaré tu reseña tras una breve revisión.", error: "Algo no ha funcionado. Inténtalo de nuevo.", errorRating: "Elige una valoración de 1 a 5 estrellas.", errorQuote: "Escribe al menos diez caracteres." },
    booking: {
      overline: "Reservar", title: "Elige tu velada.", sub: "Una sola reserva al día para dedicarte toda mi atención. Bloquea tu fecha ahora con un depósito de 50 € — confirmación inmediata.",
      name: "Nombre y apellido", email: "Email", phone: "Teléfono (WhatsApp)",
      classType: "Qué paquete", coppie: "Parejas · Romántico", gruppo: "Pequeño grupo", tartufo: "Trufa & Champán", degustazione: "Cena Degustación", evento: "Evento privado/corporativo",
      date: "Fecha preferida", pickDate: "Elige una fecha", invalidEmail: "Correo electrónico no válido — revísalo e inténtalo de nuevo", slot: "Horario preferido", slotHint: "Ej. 13:00 para comida, 19:30 para cena — lo afinamos juntos.",
      guests: "Número de huéspedes", message: "Mensaje (alergias, ocasiones, notas)",
      submit: "Enviar solicitud", sending: "Enviando…", success: "¡Solicitud enviada! Te respondo en 24 horas.", error: "Algo no ha funcionado. Inténtalo de nuevo.",
      confirmedTitle: "¡Solicitud recibida!", confirmedSub: "Gracias. Te respondo personalmente en 24 horas por email o WhatsApp para confirmar disponibilidad y detalles.",
      depositTitle: "¿Quieres bloquear la fecha ahora?", depositSub: "Para confirmar la reserva y mantener la terraza solo para ti, puedes pagar el depósito de forma segura vía Stripe.", depositCta: "Pagar el depósito", depositSecure: "Pago seguro vía Stripe", newBooking: "Nueva solicitud",
      payButton: "Ir al pago", payAmount: "Depósito 50 €", payHint: "Serás redirigido a Stripe para completar el pago de forma segura.",
      paidTitle: "¡Reserva confirmada!", paidSub: "Tu depósito ha sido registrado y la fecha está oficialmente bloqueada en la terraza. Recibirás la dirección exacta y todos los detalles por email 48 horas antes de la experiencia.",
      cancelTitle: "Pago cancelado",
      cancelSub: "No se ha realizado ningún cargo. Tu solicitud sigue pendiente: puedes completar el pago más tarde o escribirnos por WhatsApp.",
      retry: "Reintentar pago", backHome: "Volver al inicio", checkingPayment: "Comprobando el pago…",
    },
    faq: {
      overline: "Preguntas frecuentes", title: "Antes de reservar.",
      items: [
        { q: "¿Dónde está la terraza?", a: "En el corazón del centro histórico, a dos pasos de la Plaza de España. Te envío la dirección exacta al confirmar." },
        { q: "¿Qué incluye?", a: "Aperitivo, todos los ingredientes, vino de los Castelli, agua y café. Sin costes ocultos." },
        { q: "¿Vegetarianos / alergias?", a: "Por supuesto. Escríbelo en el mensaje y adapto el menú — soy chef, nunca es un problema." },
        { q: "¿Y si llueve?", a: "La terraza tiene una zona cubierta. Con mal tiempo serio nos trasladamos a la cocina, que también es parte de la experiencia." },
        { q: "¿Cómo se paga?", a: "Al confirmar pido un pequeño anticipo por transferencia o PayPal. El resto la noche, en efectivo o tarjeta." },
        { q: "¿Mínimo de huéspedes?", a: "Desde 2 huéspedes. Máximo 6 para la cooking class, 8 para la degustación." },
      ],
    },
    google: { overline: "Reseñas de Google", basedOn: "Basado en {{n}} reseñas verificadas", verifiedOnGoogle: "Verificado en Google", writeReview: "Escribir una reseña" },
    footer: { tagline: "Cooking experiences privadas · Plaza de España, Roma", rights: "Todos los derechos reservados.", contacts: "Contacto", cookiePolicy: "Política de cookies", cookieSettings: "Preferencias de cookies" },
    cookies: {
      bannerTitle: "Usamos cookies",
      bannerBody: "Utilizamos cookies necesarias para el funcionamiento del sitio y, con tu consentimiento, cookies analíticas para entender cómo se usa. Ningún cookie publicitario.",
      readPolicy: "Leer la política de cookies",
      acceptAll: "Aceptar todo",
      rejectAll: "Rechazar",
      customize: "Personalizar",
      prefsOverline: "Preferencias",
      prefsTitle: "Gestionar cookies",
      prefsSub: "Elige qué cookies permitir. Puedes cambiar de opinión en cualquier momento desde el enlace en el pie de página.",
      necessaryTitle: "Cookies necesarias",
      necessaryDesc: "Imprescindibles para el funcionamiento del sitio (idioma, preferencias, pagos seguros). No requieren consentimiento.",
      analyticsTitle: "Cookies analíticas",
      analyticsDesc: "Google Analytics y PostHog para medir de forma anónima cómo se usa el sitio y mejorarlo. IP anonimizada.",
      alwaysActive: "Siempre activas",
      savePrefs: "Guardar preferencias",
    },
    cookiePolicy: {
      overline: "Aviso legal",
      title: "Política de cookies",
      lastUpdated: "Última actualización",
      updateDate: "Febrero 2026",
      back: "Volver al inicio",
      intro: "Esta política de cookies explica qué cookies y tecnologías similares utiliza el sitio eternalcityview.com (el «Sitio»), gestionado por Alessandro Pivano. El Sitio respeta tu privacidad: no se instala ninguna cookie no esencial sin tu consentimiento explícito.",
      whatAreTitle: "Qué son las cookies",
      whatAreBody: "Las cookies son pequeños archivos de texto que los sitios visitados envían a tu dispositivo, donde se almacenan para ser reenviados a los mismos sitios en la próxima visita. También usamos tecnologías similares (localStorage) para guardar tus preferencias.",
      typesTitle: "Tipos de cookies utilizadas",
      necessaryTitle: "Cookies técnicas (necesarias)",
      necessaryBody: "Necesarias para el funcionamiento del Sitio, para memorizar el idioma seleccionado y para procesar los pagos de forma segura a través de Stripe. No requieren consentimiento según el RGPD.",
      analyticsTitle: "Cookies analíticas (opcionales)",
      analyticsBody: "Utilizamos Google Analytics 4 y PostHog para recopilar información agregada y anónima sobre el uso del Sitio (páginas vistas, duración de las sesiones, dispositivo, procedencia). La IP está anonimizada. Estas cookies se instalan solo con tu consentimiento.",
      tableTitle: "Cookies utilizadas en el Sitio",
      thName: "Nombre",
      thProvider: "Proveedor",
      thPurpose: "Finalidad",
      thDuration: "Duración",
      rowGaPurpose: "Estadísticas de uso agregadas y anónimas",
      rowPhPurpose: "Analítica de producto y session replay anonimizado",
      rowConsentPurpose: "Guarda tus preferencias de cookies",
      rowLangPurpose: "Guarda el idioma seleccionado",
      rowStripePurpose: "Procesamiento seguro del pago (depósito)",
      duration2y: "2 años",
      duration1y: "1 año",
      duration6m: "6 meses",
      durationPersistent: "Persistente",
      manageTitle: "Cómo gestionar el consentimiento",
      manageBody: "Puedes modificar o retirar tus preferencias en cualquier momento haciendo clic en el botón siguiente.",
      manageCta: "Gestionar preferencias de cookies",
      browserNote: "También puedes bloquear o eliminar las cookies directamente desde la configuración de tu navegador (Chrome, Safari, Firefox, Edge, etc.). Desactivar las cookies técnicas puede afectar al funcionamiento correcto del Sitio.",
      rightsTitle: "Tus derechos (RGPD)",
      rightsBody: "De conformidad con el Reglamento UE 2016/679 (RGPD), tienes derecho de acceso, rectificación, supresión, limitación y portabilidad de tus datos personales, así como derecho de oposición y a reclamar ante la autoridad de control.",
      contactTitle: "Contacto",
      contactBody: "Para cualquier pregunta sobre esta política de cookies o el tratamiento de tus datos, escríbenos a",
    },
    floating: { question: "¿Una pregunta rápida?", sub: "Escríbeme por WhatsApp, te respondo personalmente.", cta: "Abrir WhatsApp", greeting: "Hola Alessandro, querría información sobre los cursos de cocina en la terraza.", emailSub: "¿Prefieres email? Escríbeme, respondo en pocas horas.", emailCta: "Abrir Email", emailSubject: "Información cursos de cocina en la terraza", emailBody: "Hola Alessandro,\n\nquerría información sobre los cursos de cocina en la terraza.\n\nGracias," },
    admin: {
      addReview: "+ Añadir reseña", cancel: "Cancelar", publish: "Publicar", addReviewValidation: "Rellena nombre, ciudad y texto (mín 10 car.).", addReviewSuccess: "Reseña publicada", reviewLanguage: "Idioma",
      gallery: "Galería", uploadPhotos: "Subir fotos", noPhotos: "Aún no hay fotos.",
      title: "Admin", loginTitle: "Acceso", password: "Contraseña", login: "Entrar", logout: "Salir",
      bookings: "Reservas", reviewsTitle: "Reseñas", noBookings: "Sin reservas.", noReviews: "Sin reseñas.", wrongPassword: "Contraseña inválida.",
      columns: { date: "Fecha", slot: "Horario", class: "Experiencia", guests: "Huéspedes", name: "Nombre", contact: "Contacto", message: "Notas", received: "Recibida", status: "Estado", actions: "Acciones" },
      reviewColumns: { rating: "Valoración", name: "Nombre", origin: "Ciudad", quote: "Texto", received: "Recibida", status: "Estado", actions: "Acciones" },
      statuses: { pending: "Pendiente", abandoned: "Abandonada", expired: "Caducada", pending_payment: "Pago pendiente", failed: "Fallida", confirmed: "Confirmada", cancelled: "Cancelada", approved: "Aprobada", rejected: "Rechazada" },
      confirm: "Confirmar", cancel: "Cancelar", delete: "Eliminar", approve: "Aprobar", reject: "Rechazar", all: "Todas",
    },
  },

  de: {
    nav: { classes: "Erlebnisse", about: "Der Chef", experience: "Der Abend", gallery: "Galerie", testimonials: "Gäste", book: "Buchen", admin: "Admin" },
    hero: { overline: "Privates Cooking-Erlebnis · Spanische Treppe", title: "Ewiges Rom,\nvon meiner Terrasse.", sub: "Ein intimes kulinarisches Erlebnis über den Dächern der Altstadt. Aperitif bei Sonnenuntergang, frische Pasta mit dem Chefkoch, Tiramisù und Verkostung dessen, was du geschaffen hast.", cta: "Einen Abend buchen", ctaGhost: "Die Erlebnisse entdecken" },
    ribbon: "Frische handgemachte Pasta · Blick auf die Spanische Treppe · Römische Rezepte · Signature-Tiramisù · Gäste, keine Kunden",
    classes: {
      overline: "Die Pakete", title: "Drei Erlebnisse, um Rom\nvon der Dachterrasse zu erleben.",
      coppie: { title: "Paare · Romantisch", persons: "2 Personen", price: "170 € / Person", desc: "Private Cooking Class mit frischer Pasta und Tiramisù, Verkostung auf der Terrasse bei Sonnenuntergang mit Blick auf die Dächer der Altstadt. Lokale Weine inklusive.", cta: "Buchen" },
      gruppo: { title: "Kleine Gruppe", persons: "4–8 Personen", price: "150 € / Person", desc: "Dasselbe Erlebnis im geselligen Format, ideal für Familien oder Freundesgruppen auf Reisen. Lokale Weine inklusive.", cta: "Buchen" },
      tartufo: { title: "Trüffel & Champagner", persons: "2–6 Personen", price: "250 € / Person", desc: "Signature-Erlebnis mit Verkostung frischer Trüffel, begleitendem Champagner, Cooking Class für frische Pasta und Tiramisù sowie Verkostung auf der Terrasse bei Sonnenuntergang.", cta: "Buchen", badge: "Premium" },
      degustazione: { title: "Verkostungsdinner", persons: "2–8 Personen", price: "150 € / Person", desc: "Vom Chef kuratiertes Verkostungsdinner auf der Terrasse bei Sonnenuntergang: Antipasti, Pasta-Hauptgang, römischer zweiter Gang, Tiramisù. Zurücklehnen und genießen — wir kochen für dich.", cta: "Buchen" },
      evento: { title: "Private / Firmenevents", persons: "Auf Anfrage", price: "Auf Anfrage", desc: "Maßgeschneidertes Erlebnis für Team Building, Feiern, Junggesellen- oder Junggesellinnenabschiede.", cta: "Auf WhatsApp schreiben" },
      note: "Menü und Weinauswahl können nach Vorlieben und Bedürfnissen (Allergien, Unverträglichkeiten, Sonderwünsche) individuell angepasst werden. Kontaktiere uns für dein maßgeschneidertes Erlebnis.",
      buildEvening: {
      navLink: "Build your evening",
      heroOverline: "Build your evening",
      heroTitle: "Gestalte deinen Abend",
      heroSub: "Wähle Erlebnis, Menü und Weine. 50 € Anzahlung online, Rest am Abend auf der Terrasse.",
      step1Title: "Dein Erlebnis",
      step2Title: "Dein Menü",
      step3Title: "Deine Weine",
      step4Title: "Deine Daten",
      guestsLabel: "Gäste",
      dateLabel: "Datum",
      timeLabel: "Uhrzeit",
      perPerson: "/ Person",
      perBottle: "/ Flasche",
      bottlesLabel: "Flaschen",
      bottleLabel: "Flasche",
      guestsSuffix: "Gäste",
      wineNote: "Weine werden am Abend direkt auf der Terrasse bezahlt.",
      experiences: {
        coppie: { title: "Paare · Romantisch", persons: "2 Gäste", desc: "Privater Sonnenuntergangs-Abend zu zweit." },
        gruppo: { title: "Kleine Gruppe", persons: "4–8 Gäste", desc: "Geselliges Format für Familien oder Reisefreunde." },
      },
      menus: {
        tradizione: { name: "Römische Tradition", desc: "Römische Antipasti, frische Pasta (Cacio e Pepe oder Amatriciana), Tiramisù, Kaffee und hausgemachter Limoncello." },
        pesce: { name: "Fisch-Verkostung", desc: "Meeresantipasti, frische Pasta mit Meeresfrüchten, Dessert des Chefs, Kaffee und hausgemachter Limoncello." },
        tartufo: { name: "Weißer Trüffel", desc: "Trüffel-Antipasti, Tagliolini mit frischem weißem Trüffel, Tiramisù, Kaffee und hausgemachter Limoncello." },
      },
      wineCategories: { white: "Weißweine", red: "Rotweine", rose: "Rosé", sparkling: "Schaumweine", champagne: "Champagner" },
      summaryTitle: "Dein Abend",
      experienceRow: "Erlebnis",
      menuRow: "Menü",
      winesRow: "Weine",
      totalLabel: "Gesamt",
      depositLabel: "Anzahlung jetzt (Stripe)",
      balanceLabel: "Rest am Abend",
      formTitle: "Wer bist du?",
      nameLabel: "Vor- und Nachname",
      emailLabel: "E-Mail",
      phoneLabel: "Telefon (WhatsApp)",
      notesLabel: "Hinweise (Allergien, Unverträglichkeiten, Anlässe)",
      bookNow: "Mit 50 € Anzahlung buchen",
      bookingSuccess: "Perfekt! Du wirst zur sicheren Zahlung weitergeleitet…",
      bookingError: "Etwas ist schiefgelaufen. Versuche es erneut oder schreib uns auf WhatsApp.",
      selectRequired: "Wähle Erlebnis, Menü und Datum, um fortzufahren.",
      noWines: "Keine Weine gewählt (du kannst auch deinen eigenen mitbringen).",
      removeWine: "Entfernen",
    },
    terraceTitle: "Die Terrasse",
      terraceSub: "Wenige Schritte von der Spanischen Treppe entfernt, zwischen Kirchtürmen und Dächern aus dem 17. Jahrhundert.",
      detailsCta: "Mehr erfahren",
    },
    experiences: {
      backToAll: "← Alle Erlebnisse",
      backHome: "← Zur Startseite",
      durationLabel: "Dauer",
      guestsLabel: "Gäste",
      priceLabel: "Preis",
      includesTitle: "Was ist inbegriffen",
      flowTitle: "So läuft der Abend ab",
      whyTitle: "Warum dieses Erlebnis wählen",
      bookNow: "Dieses Erlebnis buchen",
      otherTitle: "Weitere Erlebnisse auf der Terrasse",
      badgePremium: "Premium",
      pageTitleSuffix: " · Eternal City View",
      coppie: {
        metaTitle: "Romantische Cooking Class in Rom für Paare",
        metaDescription: "Privater Abend auf der Terrasse an der Spanischen Treppe zu zweit: frische Pasta zu vier Händen, Tiramisù, Aperitif bei Sonnenuntergang und Dinner mit Blick auf die Dächer Roms.",
        heroTagline: "Nur ihr beide, der Sonnenuntergang und Rom unter der Terrasse.",
        descLong: "Ein Abend für Paare: private Cooking Class mit Chef Alessandro, Aperitif bei Sonnenuntergang und Candle-Light-Dinner auf der Terrasse mit Panoramablick auf die Dächer der Altstadt. Perfekt für Jahrestage, Heiratsanträge, Flitterwochen oder einfach einen unvergesslichen Abend in Rom.",
        duration: "≈ 3 Stunden",
        includes: [
          "Private Cooking Class für frische Pasta zu vier Händen",
          "Zubereitung des hauseigenen Tiramisù",
          "Sonnenuntergangs-Aperitif mit Begrüßungsglas",
          "Vollständiges Dinner mit Castelli-Wein, Wasser und Kaffee",
          "Exklusiver Panoramablick über die Dächer Roms",
        ],
        flow: [
          "Empfang auf der Terrasse mit Sonnenuntergangsglas",
          "Cooking Class: Teig, Pasta und Tiramisù",
          "Romantisches Dinner mit den gemeinsam zubereiteten Gerichten",
          "Kaffee, Digestif und lange Verabschiedung unter den Sternen",
        ],
        why: [
          "Volle Privatsphäre — nur ihr beide",
          "Anpassbar für Jahrestage oder Anträge",
          "Menü an Allergien und Vorlieben angepasst",
        ],
      },
      gruppo: {
        metaTitle: "Cooking Class für kleine Gruppen in Rom · Terrasse Spanische Treppe",
        metaDescription: "Geselliges Kocherlebnis für 4-8 Personen auf der Terrasse im Herzen Roms: handgemachte frische Pasta, Tiramisù und Sonnenuntergangs-Dinner mit Panoramablick.",
        heroTagline: "Eure Runde, die Terrasse Roms, ein unvergesslicher Abend.",
        descLong: "Das perfekte Erlebnis für Familien, reisende Freunde oder kleine Gruppen, die etwas wirklich Besonderes teilen möchten. Gesellige Cooking Class mit Chef Alessandro auf der Terrasse an der Spanischen Treppe, Aperitif bei Sonnenuntergang und Dinner mit den gemeinsam zubereiteten Gerichten.",
        duration: "≈ 3 Stunden",
        includes: [
          "Gruppen-Cooking-Class für frische Pasta",
          "Zubereitung des Tiramisù des Chefs",
          "Sonnenuntergangs-Aperitif mit Häppchen",
          "Vollständiges Dinner mit Castelli-Wein, Wasser und Kaffee",
          "Panoramablick über die Dächer der Altstadt",
        ],
        flow: [
          "Empfang auf der Terrasse mit Aperitif",
          "Gesellige Cooking Class zu vielen Händen",
          "Gruppen-Dinner mit den zubereiteten Gerichten",
          "Kaffee, Gespräche und abschließender Digestif",
        ],
        why: [
          "Geselliges Format ideal für Freundesgruppen",
          "Familienfreundlich (Menü für Kinder anpassbar)",
          "Eine Rom-Erinnerung, die ihr zusammen mit nach Hause nehmt",
        ],
      },
      tartufo: {
        metaTitle: "Trüffel & Champagner Erlebnis in Rom · Premium Cooking Class",
        metaDescription: "Signature-Erlebnis auf der Terrasse an der Spanischen Treppe: Verkostung frischer Trüffel, begleitender Champagner, Cooking Class für frische Pasta und Sonnenuntergangs-Dinner.",
        heroTagline: "Frische Trüffel, Champagner und die Dächer Roms im Sonnenuntergang.",
        descLong: "Das Premium-Signature-Erlebnis von Eternal City View: geführte Trüffelverkostung, begleitender Champagner, Cooking Class für Trüffel-Pasta und exklusives Dinner auf der Terrasse mit Panoramablick. Ein maßgeschneidertes Event für anspruchsvolle Gaumen oder wirklich besondere Anlässe.",
        duration: "≈ 3,5 Stunden",
        includes: [
          "Geführte Verkostung frischer Trüffel",
          "Begleitendes Glas Champagner",
          "Private Cooking Class für frische Trüffel-Pasta",
          "Hauseigenes Tiramisù und vollständiges Dinner",
          "Ausgewählte Weine, Wasser und Kaffee",
          "Exklusiver Panoramablick über Rom",
        ],
        flow: [
          "Champagner-Aperitif bei Sonnenuntergang",
          "Geführte Verkostung frischer Trüffel",
          "Cooking Class für frische Trüffel-Pasta",
          "Signature-Dinner mit Weinbegleitung",
          "Digestif, Dessert und lange Verabschiedung",
        ],
        why: [
          "Ein einzigartiges Gourmet-Erlebnis in Rom",
          "Vom Chef ausgewählte Premium-Zutaten",
          "Perfekt für Feieranlässe",
        ],
      },
      degustazione: {
        metaTitle: "Verkostungsdinner auf der Terrasse · Spanische Treppe, Rom",
        metaDescription: "Vom Chef kuratiertes Verkostungsdinner auf der Terrasse an der Spanischen Treppe: Antipasti, frische Pasta, römischer Hauptgang, Tiramisù. Zurücklehnen — wir kochen für Sie.",
        heroTagline: "Setzt euch, stoßt an und lasst euch vom Chef leiten.",
        descLong: "Diesmal keine Cooking Class: nur du, deine Gäste und die Küche des Chefs. Ein komplettes Mehrgang-Verkostungsdinner auf der Terrasse bei Sonnenuntergang, mit einem von Alessandro entworfenen Menü. Perfekt für alle, die Rom entspannt genießen möchten – mit der Sorgfalt einer Familientafel und der Präzision eines Chefs.",
        duration: "≈ 2,5 Stunden",
        includes: [
          "Antipasti des Chefs",
          "Hauptgang aus handgemachter frischer Pasta",
          "Zweiter Gang aus der römischen Tradition",
          "Hauseigenes Tiramisù",
          "Castelli-Wein, Wasser und Kaffee",
          "Tischservice auf der Terrasse",
        ],
        flow: [
          "Begrüßungs-Aperitif bei Sonnenuntergang",
          "Antipasti des Chefs",
          "Haupt- und zweiter Gang am Tisch serviert",
          "Dessert, Kaffee und abschließender Digestif",
        ],
        why: [
          "Ideal für alle, die nur das Dinner wollen (keine Cooking Class)",
          "Saisonales Menü vom Chef kreiert",
          "Entspanntes Tempo, Panoramablick",
        ],
      },
    },
    about: { overline: "Der Chef", title: "Ich bin Alessandro.\nWillkommen auf meiner Terrasse.", body: "Ich koche, seit ich ein Kind war, im Restaurant meiner Mutter — traditionelle römische Küche, ohne Kompromisse. Ich habe an der Italian Chef Academy abgeschlossen und mich durch Catering und gehobene Küchen gearbeitet.\n\nHeute habe ich beschlossen, all das zu mir nach Hause zu bringen, auf die Terrasse wenige Schritte von der Spanischen Treppe entfernt. Keine vollen Säle mehr: nur du, deine Gäste, die Dächer Roms und ein Abendessen wie in der Familie — aber mit der Hand eines Chefkochs.", signature: "— Alessandro Pivano" },
    experience: {
      seo: "Suchst du eine private Cooking Class in Rom nahe der Spanischen Treppe? Eternal City View bietet ein intimes Erlebnis auf der Dachterrasse, nur wenige Schritte von der Piazza di Spagna entfernt — handgemachte Pasta, römische Rezepte und ein Abendessen bei Sonnenuntergang mit Panoramablick auf das historische Zentrum. Anders als große Kochschulen für Gruppen ist dies ein privater, vom Chef geleiteter Abend für Paare, Familien und kleine Gruppen, die Rom besuchen.",
      overline: "Der Abend", title: "Kein Restaurant.\nEin Abend bei mir.",
      items: [
        { tag: "01", title: "Aperitif", text: "Ich empfange dich auf der Terrasse mit einem Glas und ein paar Häppchen, während die Sonne über der Spanischen Treppe untergeht." },
        { tag: "02", title: "Wir kochen zusammen", text: "Für die Cooking Class: eine Sorte frischer Pasta zu vier Händen, dann Tiramisù. Chef-Techniken, Familienrhythmus." },
        { tag: "03", title: "Am Tisch", text: "Wir essen die Gerichte, die du zubereitet hast (oder die der Chef serviert), begleitet von Castelli-Wein und warmem Brot." },
        { tag: "04", title: "Lange Verabschiedung", text: "Kaffee, vielleicht ein Digestif, und lange Gespräche, um den Abend gebührend abzuschließen." },
      ],
    },
    gallery: { overline: "Galerie", title: "Die Terrasse, die Teller,\ndas Licht Roms.", sub: "Echte Momente von Abenden auf der Terrasse. Tippe auf ein Bild, um es zu vergrößern.", close: "Schließen", prev: "Zurück", next: "Weiter" },
    testimonials: {
      overline: "Die Gäste", shareTitle: "Hast du auf der Terrasse gegessen?", shareSub: "Hinterlasse eine Bewertung, du hilfst mir, das Projekt bekannter zu machen.", shareCta: "Bewertung schreiben", orGoogle: "oder bei Google", shareSection: "Warst du Gast?",
      emptyTitle: "Die Stimmen der ersten Gäste\nerscheinen hier.",
      emptySub: "Eternal City View hat soeben die Türen der Terrasse geöffnet. Wenn du hier gegessen hast, wird deine Bewertung die erste sein, die jene lesen, die das Projekt entdecken.",
      emptyCta: "Sei der Erste",
    },
    reviews: { overline: "Bewertungen", formTitle: "Deine Bewertung", formSub: "Ich veröffentliche deine Bewertung nach einer kurzen Prüfung. Vielen Dank — Mundpropaganda ist das Wertvollste in diesem Beruf.", rating: "Bewertung", name: "Name", namePh: "Z. B. Marco R.", origin: "Stadt", originPh: "Z. B. Rom, Boston…", text: "Deine Erfahrung", textPh: "Was bleibt vom Abend? Rezept, Atmosphäre, Aussicht, alles…", submit: "Bewertung senden", sending: "Senden…", cancel: "Abbrechen", success: "Danke! Ich veröffentliche deine Bewertung nach einer kurzen Prüfung.", error: "Etwas ist schiefgelaufen. Versuche es erneut.", errorRating: "Wähle eine Bewertung von 1 bis 5 Sternen.", errorQuote: "Schreibe mindestens zehn Zeichen." },
    booking: {
      overline: "Buchung", title: "Wähle deinen Abend.", sub: "Ich antworte persönlich innerhalb von 24 Stunden mit Verfügbarkeit und Details.",
      name: "Vor- und Nachname", email: "E-Mail", phone: "Telefon (WhatsApp)",
      classType: "Welches Paket", coppie: "Paare · Romantisch", gruppo: "Kleine Gruppe", tartufo: "Trüffel & Champagner", degustazione: "Verkostungsdinner", evento: "Private/Firmenevents",
      date: "Wunschdatum", pickDate: "Datum wählen", invalidEmail: "Ungültige E-Mail-Adresse — bitte prüfen und erneut versuchen", slot: "Wunschuhrzeit", slotHint: "Z. B. 13:00 für Mittag, 19:30 für Abend — wir stimmen es gemeinsam ab.",
      guests: "Anzahl Gäste", message: "Nachricht (Allergien, Anlass, Hinweise)",
      submit: "Anfrage senden", sending: "Wird gesendet…", success: "Anfrage gesendet! Ich antworte innerhalb von 24 Stunden.", error: "Etwas ist schiefgelaufen. Versuche es erneut.",
      confirmedTitle: "Anfrage erhalten!", confirmedSub: "Danke. Ich antworte persönlich innerhalb von 24 Stunden per E-Mail oder WhatsApp, um Verfügbarkeit und Details zu bestätigen.",
      depositTitle: "Datum jetzt blockieren?", depositSub: "Um die Buchung zu bestätigen und die Terrasse exklusiv für dich zu reservieren, kannst du die Anzahlung sicher über Stripe tätigen.", depositCta: "Anzahlung leisten", depositSecure: "Sichere Zahlung über Stripe", newBooking: "Neue Anfrage",
      payButton: "Weiter zur Zahlung", payAmount: "Anzahlung 50 €", payHint: "Du wirst zu Stripe weitergeleitet, um die Zahlung sicher abzuschließen.",
      paidTitle: "Buchung bestätigt!", paidSub: "Deine Anzahlung ist eingegangen und dein Termin auf der Terrasse ist offiziell reserviert. Die genaue Adresse und alle Details erhältst du per E-Mail 48 Stunden vor dem Erlebnis.",
      cancelTitle: "Zahlung abgebrochen",
      cancelSub: "Es wurde nichts abgebucht. Deine Anfrage bleibt offen: Du kannst die Zahlung später abschließen oder uns per WhatsApp erreichen.",
      retry: "Zahlung wiederholen", backHome: "Zur Startseite", checkingPayment: "Zahlung wird geprüft…",
    },
    faq: {
      overline: "Häufige Fragen", title: "Vor der Buchung.",
      items: [
        { q: "Wo ist die Terrasse?", a: "Im Herzen der Altstadt, wenige Schritte von der Spanischen Treppe entfernt. Die genaue Adresse sende ich bei Bestätigung." },
        { q: "Was ist inbegriffen?", a: "Aperitif, alle Zutaten, Castelli-Wein, Wasser und Kaffee. Keine versteckten Kosten." },
        { q: "Vegetarier / Allergien?", a: "Selbstverständlich. Schreibe es in die Nachricht und ich passe das Menü an — ich bin Chefkoch, das ist nie ein Problem." },
        { q: "Bei Regen?", a: "Die Terrasse hat einen überdachten Bereich. Bei wirklich schlechtem Wetter verlegen wir alles in die Küche, die auch Teil des Erlebnisses ist." },
        { q: "Wie wird bezahlt?", a: "Bei Bestätigung verlange ich eine kleine Anzahlung per Überweisung oder PayPal. Der Rest am Abend selbst, bar oder mit Karte." },
        { q: "Mindestens?", a: "Ab 2 Gästen. Maximal 6 für die Cooking Class, 8 für die Verkostung." },
      ],
    },
    google: { overline: "Google Bewertungen", basedOn: "Basierend auf {{n}} verifizierten Bewertungen", verifiedOnGoogle: "Verifiziert auf Google", writeReview: "Bewertung schreiben" },
    footer: { tagline: "Private Cooking-Erlebnisse · Spanische Treppe, Rom", rights: "Alle Rechte vorbehalten.", contacts: "Kontakt", cookiePolicy: "Cookie-Richtlinie", cookieSettings: "Cookie-Einstellungen" },
    cookies: {
      bannerTitle: "Wir verwenden Cookies",
      bannerBody: "Wir verwenden notwendige Cookies für die Funktion der Website und, mit deiner Zustimmung, Analyse-Cookies, um zu verstehen, wie sie genutzt wird. Keine Werbe- oder Profiling-Cookies.",
      readPolicy: "Cookie-Richtlinie lesen",
      acceptAll: "Alle akzeptieren",
      rejectAll: "Ablehnen",
      customize: "Anpassen",
      prefsOverline: "Einstellungen",
      prefsTitle: "Cookies verwalten",
      prefsSub: "Wähle, welche Cookies zugelassen werden. Du kannst deine Meinung jederzeit über den Link im Footer ändern.",
      necessaryTitle: "Notwendige Cookies",
      necessaryDesc: "Unverzichtbar für die Funktion der Website (Sprache, Präferenzen, sichere Zahlungen). Keine Einwilligung erforderlich.",
      analyticsTitle: "Analyse-Cookies",
      analyticsDesc: "Google Analytics und PostHog zur anonymen Messung der Website-Nutzung und Verbesserung. IP anonymisiert.",
      alwaysActive: "Immer aktiv",
      savePrefs: "Einstellungen speichern",
    },
    cookiePolicy: {
      overline: "Rechtliches",
      title: "Cookie-Richtlinie",
      lastUpdated: "Letzte Aktualisierung",
      updateDate: "Februar 2026",
      back: "Zur Startseite",
      intro: "Diese Cookie-Richtlinie erläutert, welche Cookies und ähnlichen Technologien die Website eternalcityview.com (die \"Website\") verwendet, betrieben von Alessandro Pivano. Die Website ist so gestaltet, dass sie deine Privatsphäre respektiert: Es werden keine nicht notwendigen Cookies ohne deine ausdrückliche Zustimmung installiert.",
      whatAreTitle: "Was sind Cookies",
      whatAreBody: "Cookies sind kleine Textdateien, die besuchte Websites an dein Gerät senden und dort gespeichert werden, um sie bei deinem nächsten Besuch an dieselben Websites zurückzusenden. Wir verwenden auch ähnliche Technologien (localStorage), um deine Einstellungen zu speichern.",
      typesTitle: "Verwendete Cookie-Arten",
      necessaryTitle: "Technische Cookies (notwendig)",
      necessaryBody: "Erforderlich für die Funktion der Website, zur Speicherung der gewählten Sprache und zur sicheren Zahlungsabwicklung über Stripe. Nach DSGVO keine Einwilligung erforderlich.",
      analyticsTitle: "Analyse-Cookies (optional)",
      analyticsBody: "Wir verwenden Google Analytics 4 und PostHog, um aggregierte und anonyme Informationen darüber zu sammeln, wie Besucher die Website nutzen (aufgerufene Seiten, Sitzungsdauer, Gerät, Herkunft). Die IP-Adresse ist anonymisiert. Diese Cookies werden nur mit deiner Zustimmung installiert.",
      tableTitle: "Auf der Website verwendete Cookies",
      thName: "Name",
      thProvider: "Anbieter",
      thPurpose: "Zweck",
      thDuration: "Dauer",
      rowGaPurpose: "Aggregierte und anonyme Nutzungsstatistiken",
      rowPhPurpose: "Produktanalyse und anonymisiertes Session-Replay",
      rowConsentPurpose: "Speichert deine Cookie-Einstellungen",
      rowLangPurpose: "Speichert die gewählte Sprache",
      rowStripePurpose: "Sichere Zahlungsabwicklung (Anzahlung)",
      duration2y: "2 Jahre",
      duration1y: "1 Jahr",
      duration6m: "6 Monate",
      durationPersistent: "Dauerhaft",
      manageTitle: "Einwilligung verwalten",
      manageBody: "Du kannst deine Einstellungen jederzeit über die Schaltfläche unten ändern oder widerrufen.",
      manageCta: "Cookie-Einstellungen verwalten",
      browserNote: "Du kannst Cookies auch direkt in den Einstellungen deines Browsers (Chrome, Safari, Firefox, Edge usw.) blockieren oder löschen. Das Deaktivieren technischer Cookies kann die Funktion der Website beeinträchtigen.",
      rightsTitle: "Deine Rechte (DSGVO)",
      rightsBody: "Gemäß Verordnung (EU) 2016/679 (DSGVO) hast du das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung und Übertragbarkeit deiner personenbezogenen Daten sowie das Recht auf Widerspruch und Beschwerde bei der zuständigen Aufsichtsbehörde.",
      contactTitle: "Kontakt",
      contactBody: "Bei Fragen zu dieser Cookie-Richtlinie oder zur Verarbeitung deiner Daten schreibe uns an",
    },
    floating: { question: "Eine kurze Frage?", sub: "Schreib mir auf WhatsApp, ich antworte persönlich.", cta: "WhatsApp öffnen", greeting: "Hallo Alessandro, ich hätte gerne Informationen zu den Kochkursen auf der Terrasse.", emailSub: "Lieber per E-Mail? Schreib mir, ich antworte innerhalb weniger Stunden.", emailCta: "E-Mail öffnen", emailSubject: "Anfrage zu Kochkursen auf der Terrasse", emailBody: "Hallo Alessandro,\n\nich hätte gerne Informationen zu den Kochkursen auf der Terrasse.\n\nDanke," },
    admin: {
      addReview: "+ Rezension hinzufügen", cancel: "Abbrechen", publish: "Veröffentlichen", addReviewValidation: "Bitte Name, Stadt und Text ausfüllen (min. 10 Zeichen).", addReviewSuccess: "Rezension veröffentlicht", reviewLanguage: "Sprache",
      gallery: "Galerie", uploadPhotos: "Fotos hochladen", noPhotos: "Noch keine Fotos.",
      title: "Admin", loginTitle: "Anmelden", password: "Passwort", login: "Eintreten", logout: "Abmelden",
      bookings: "Buchungen", reviewsTitle: "Bewertungen", noBookings: "Keine Buchungen.", noReviews: "Keine Bewertungen.", wrongPassword: "Falsches Passwort.",
      columns: { date: "Datum", slot: "Uhrzeit", class: "Erlebnis", guests: "Gäste", name: "Name", contact: "Kontakt", message: "Notizen", received: "Erhalten", status: "Status", actions: "Aktionen" },
      reviewColumns: { rating: "Bewertung", name: "Name", origin: "Stadt", quote: "Text", received: "Erhalten", status: "Status", actions: "Aktionen" },
      statuses: { pending: "Ausstehend", abandoned: "Abgebrochen", expired: "Abgelaufen", pending_payment: "Zahlung ausstehend", failed: "Fehlgeschlagen", confirmed: "Bestätigt", cancelled: "Storniert", approved: "Genehmigt", rejected: "Abgelehnt" },
      confirm: "Bestätigen", cancel: "Stornieren", delete: "Löschen", approve: "Genehmigen", reject: "Ablehnen", all: "Alle",
    },
  },

  ja: {
    nav: { classes: "体験", about: "シェフ紹介", experience: "夜のひととき", gallery: "ギャラリー", testimonials: "ゲストの声", book: "予約", admin: "管理" },
    hero: { overline: "プライベート料理体験 · スペイン広場", title: "永遠の都ローマ、\n私のテラスから。", sub: "歴史地区の屋根の上で過ごす親密な料理体験。夕日に乾杯、シェフと作る生パスタ、ティラミス、そして自分で作った料理の試食。", cta: "夜のひとときを予約", ctaGhost: "体験を見る" },
    ribbon: "手作り生パスタ · スペイン広場の眺め · ローマの伝統レシピ · 自家製ティラミス · お客様ではなくゲストとして",
    classes: {
      overline: "パッケージ", title: "屋上から楽しむローマ、\n三つの体験。",
      coppie: { title: "カップル · ロマンティック", persons: "2名", price: "€170 / 1名", desc: "プライベートの生パスタ&ティラミス クッキングクラス、そして歴史地区の屋根を望むテラスでの夕日の試食会。地元のワイン付き。", cta: "予約する" },
      gruppo: { title: "スモールグループ", persons: "4〜8名", price: "€150 / 1名", desc: "同じ体験をより賑やかなスタイルで。ご家族や旅行中のお友達グループに最適です。地元のワイン付き。", cta: "予約する" },
      tartufo: { title: "トリュフ & シャンパン", persons: "2〜6名", price: "€250 / 1名", desc: "生トリュフの試食、合わせてのシャンパン、生パスタ&ティラミスのクッキングクラス、そしてテラスでの夕日の試食会をお楽しみいただくシグネチャー体験。", cta: "予約する", badge: "Premium" },
      degustazione: { title: "テイスティングディナー", persons: "2〜8名", price: "€150 / 1名", desc: "夕日のテラスでシェフ厳選のテイスティングディナー:アンティパスト、生パスタのメイン、ローマ料理のセコンド、ティラミス。ゆっくり景色をお楽しみください — 私たちがお料理します。", cta: "予約する" },
      evento: { title: "プライベート / 法人イベント", persons: "リクエストに応じて", price: "リクエストに応じて", desc: "チームビルディング、お祝い事、独身最後のパーティーなどに合わせたオーダーメイド体験。", cta: "WhatsAppでご連絡" },
      note: "メニューとワインの選択は、お好みやご要望(アレルギー、不耐症、特別なリクエスト)に応じてカスタマイズできます。オーダーメイド体験については、お気軽にお問い合わせください。",
      buildEvening: {
      navLink: "Build your evening",
      heroOverline: "Build your evening",
      heroTitle: "あなたの夜を組み立てる",
      heroSub: "体験、メニュー、ワインを選択。オンラインで€50のデポジット、残金は夜テラスにて。",
      step1Title: "体験",
      step2Title: "メニュー",
      step3Title: "ワイン",
      step4Title: "お客様情報",
      guestsLabel: "人数",
      dateLabel: "日付",
      timeLabel: "時間",
      perPerson: "/ 1名",
      perBottle: "/ 1本",
      bottlesLabel: "本",
      bottleLabel: "本",
      guestsSuffix: "名",
      wineNote: "ワインは当日テラスで直接お支払いください。",
      experiences: {
        coppie: { title: "カップル · ロマンティック", persons: "2名", desc: "夕日のテラスで二人だけのプライベートな夜。" },
        gruppo: { title: "少人数グループ", persons: "4〜8名", desc: "ご家族や旅のお友達向けのアットホームな形式。" },
      },
      menus: {
        tradizione: { name: "ローマの伝統", desc: "ローマのアンティパスト、生パスタ(カチョエペペまたはアマトリチャーナ)、ティラミス、エスプレッソ、自家製リモンチェッロ。" },
        pesce: { name: "シーフードテイスティング", desc: "シーフードアンティパスト、魚介の生パスタ、シェフのデザート、エスプレッソ、自家製リモンチェッロ。" },
        tartufo: { name: "白トリュフ", desc: "トリュフのアンティパスト、新鮮な白トリュフのタリオリーニ、ティラミス、エスプレッソ、自家製リモンチェッロ。" },
      },
      wineCategories: { white: "白ワイン", red: "赤ワイン", rose: "ロゼ", sparkling: "スパークリング", champagne: "シャンパン" },
      summaryTitle: "あなたの夜",
      experienceRow: "体験",
      menuRow: "メニュー",
      winesRow: "ワイン",
      totalLabel: "合計",
      depositLabel: "今すぐデポジット(Stripe)",
      balanceLabel: "当夜のお支払い",
      formTitle: "お客様情報",
      nameLabel: "お名前(フルネーム)",
      emailLabel: "メール",
      phoneLabel: "電話番号(WhatsApp)",
      notesLabel: "備考(アレルギー、不耐症、記念日など)",
      bookNow: "€50デポジットで予約",
      bookingSuccess: "ありがとうございます!安全な決済ページへ移動します…",
      bookingError: "問題が発生しました。再試行するかWhatsAppでご連絡ください。",
      selectRequired: "続けるには体験、メニュー、日付を選択してください。",
      noWines: "ワインは選択されていません(お好みのものをお持ち込みいただくことも可能です)。",
      removeWine: "削除",
    },
    terraceTitle: "テラス",
      terraceSub: "スペイン広場からすぐ、17世紀の鐘楼と屋根の間に佇むテラス。",
      detailsCta: "詳しく見る",
    },
    experiences: {
      backToAll: "← すべての体験へ",
      backHome: "← ホームに戻る",
      durationLabel: "所要時間",
      guestsLabel: "人数",
      priceLabel: "料金",
      includesTitle: "含まれるもの",
      flowTitle: "夜の流れ",
      whyTitle: "この体験を選ぶ理由",
      bookNow: "この体験を予約する",
      otherTitle: "その他のテラス体験",
      badgePremium: "Premium",
      pageTitleSuffix: " · Eternal City View",
      coppie: {
        metaTitle: "ローマのカップル向けロマンティック料理体験",
        metaDescription: "スペイン広場のテラスで2名様のためのプライベートな夜:手作り生パスタ、ティラミス、夕日のアペリティーボ、ローマの屋根を望むディナー。",
        heroTagline: "お二人だけ、夕日、そして眼下に広がるローマ。",
        descLong: "カップルのための特別な夜:シェフ アレッサンドロによるプライベートなクッキングクラス、夕日のアペリティーボ、歴史地区の屋根を望むテラスでのキャンドルディナー。記念日、プロポーズ、ハネムーン、または忘れられないローマの夜に。",
        duration: "約3時間",
        includes: [
          "手作り生パスタのプライベートクッキングクラス",
          "自家製ティラミス作り",
          "ウェルカムグラス付きの夕日のアペリティーボ",
          "カステッリのワイン、水、コーヒー付きのフルディナー",
          "ローマの屋根を望む独占パノラマビュー",
        ],
        flow: [
          "夕日のグラスと共にテラスでお迎え",
          "クッキングクラス:生地、パスタ、ティラミス",
          "共に作った料理でロマンティックディナー",
          "コーヒー、ディジェスティーボ、星空の下で長いお別れ",
        ],
        why: [
          "完全プライベート — お二人だけのテラス",
          "記念日やプロポーズに合わせてカスタマイズ可能",
          "アレルギーやお好みに合わせたメニュー",
        ],
      },
      gruppo: {
        metaTitle: "ローマの少人数グループ向け料理体験 · スペイン広場のテラス",
        metaDescription: "ローマ中心のテラスで4〜8名様向けのアットホームな料理体験:手作り生パスタ、ティラミス、パノラマの夕景ディナー。",
        heroTagline: "みんなで、ローマのテラスで、忘れられない一夜。",
        descLong: "ご家族、旅仲間、少人数グループで特別なひとときを共有したい方に最適な体験。スペイン広場近くのテラスでシェフ アレッサンドロと楽しむアットホームなクッキングクラス、夕日のアペリティーボ、みんなで作った料理でディナー。",
        duration: "約3時間",
        includes: [
          "手作り生パスタのグループクッキングクラス",
          "シェフのティラミス作り",
          "夕日のアペリティーボとつまみ",
          "カステッリのワイン、水、コーヒー付きのフルディナー",
          "歴史地区の屋根を望むパノラマビュー",
        ],
        flow: [
          "テラスでアペリティーボと共にお迎え",
          "みんなで楽しむアットホームなクッキングクラス",
          "作った料理を囲むグループディナー",
          "コーヒー、おしゃべり、最後のディジェスティーボ",
        ],
        why: [
          "友達グループに最適なアットホームな形式",
          "お子様向けメニューにも対応",
          "みんなで持ち帰るローマの思い出",
        ],
      },
      tartufo: {
        metaTitle: "ローマのトリュフ&シャンパン体験 · プレミアム料理体験",
        metaDescription: "スペイン広場のテラスでのシグネチャー体験:生トリュフ試食、合わせてのシャンパン、生パスタのクッキングクラス、夕景ディナー。",
        heroTagline: "生トリュフ、シャンパン、そして夕日のローマの屋根。",
        descLong: "Eternal City ViewのシグネチャープレミアムExperience:生トリュフの試食ガイド、合わせてのシャンパン、トリュフパスタのクッキングクラス、パノラマビューのテラスでの独占ディナー。洗練された味覚や特別な機会のためのオーダーメイドイベント。",
        duration: "約3.5時間",
        includes: [
          "生トリュフの試食ガイド",
          "合わせてのシャンパン1杯",
          "トリュフ生パスタのプライベートクッキングクラス",
          "自家製ティラミスとフルディナー",
          "厳選ワイン、水、コーヒー",
          "ローマを望む独占パノラマビュー",
        ],
        flow: [
          "夕日にシャンパンでアペリティーボ",
          "生トリュフの試食ガイド",
          "トリュフ生パスタのクッキングクラス",
          "ワインペアリング付きシグネチャーディナー",
          "ディジェスティーボ、デザート、長いお別れ",
        ],
        why: [
          "ローマならではのユニークなグルメ体験",
          "シェフが厳選したプレミアム食材",
          "祝いの機会に最適",
        ],
      },
      degustazione: {
        metaTitle: "テラスでのテイスティングディナー · ローマ、スペイン広場",
        metaDescription: "スペイン広場のテラスでシェフ厳選のテイスティングディナー:アンティパスト、生パスタ、ローマ料理のセコンド、ティラミス。ゆっくりお楽しみください — 私たちがお料理します。",
        heroTagline: "座って乾杯、シェフにお任せください。",
        descLong: "今回はクッキングクラスなし:お客様、ゲスト、そしてシェフの厨房だけ。夕日のテラスで、アレッサンドロが考案したフルコースのテイスティングディナー。手間なくローマを楽しみたい方に最適 — 家庭のテーブルの温かさと、シェフの技術で。",
        duration: "約2.5時間",
        includes: [
          "シェフのアンティパスト",
          "手作り生パスタのメイン",
          "ローマの伝統料理のセコンド",
          "自家製ティラミス",
          "カステッリのワイン、水、コーヒー",
          "テラスでのテーブルサービス",
        ],
        flow: [
          "夕日にウェルカムアペリティーボ",
          "シェフのアンティパスト",
          "メインとセコンドをテーブルで",
          "デザート、コーヒー、最後のディジェスティーボ",
        ],
        why: [
          "ディナーだけを楽しみたい方に最適(クッキングクラスなし)",
          "シェフによる季節のメニュー",
          "ゆったりとしたペース、パノラマビュー",
        ],
      },
    },
    about: { overline: "シェフ紹介", title: "アレッサンドロです。\n私のテラスへようこそ。", body: "子供の頃から母のレストランで料理をしてきました。妥協のない伝統的なローマ料理です。Italian Chef Academyを卒業し、ケータリングや一流レストランで腕を磨いてきました。\n\nそして今、すべてを自宅へ — スペイン広場からすぐのテラスへ持ち帰ることにしました。混雑したホールではなく、あなたとゲスト、ローマの屋根、そして家族のように作った料理を、シェフの腕でお届けします。", signature: "— アレッサンドロ・ピヴァーノ" },
    experience: {
      seo: "スペイン広場近くのローマでプライベートなクッキングクラスをお探しですか?Eternal City Viewは、ピアッツァ・ディ・スパーニャからすぐの屋上で、親密な体験をお届けします — 手作りパスタ、ローマ料理のレシピ、そして歴史地区を望むパノラマの夕景ディナー。大人数向けの料理学校とは違い、シェフが指導するプライベートな夜を、カップル、ご家族、少人数のグループの皆さまへ。",
      overline: "夜のひととき", title: "レストランではなく、\n私の家で過ごす夜。",
      items: [
        { tag: "01", title: "アペリティーボ", text: "テラスでグラスとおつまみと共にお迎えします。スペイン広場に夕日が沈む時間です。" },
        { tag: "02", title: "一緒に料理", text: "クッキングクラスでは、1種類の生パスタを共に作り、ティラミスも仕上げます。シェフの技術、家庭のリズムで。" },
        { tag: "03", title: "テーブルへ", text: "自分で作った料理(またはシェフが盛り付けた料理)を、カステッリのワインと温かいパンと共に味わいます。" },
        { tag: "04", title: "長いお別れ", text: "コーヒー、時にはディジェスティーボ、そして長いおしゃべりで夜をきちんと締めくくります。" },
      ],
    },
    gallery: { overline: "ギャラリー", title: "テラス、料理、\nローマの光。", sub: "テラスでの夜の本物の瞬間。画像をタップすると拡大表示されます。", close: "閉じる", prev: "前へ", next: "次へ" },
    testimonials: {
      overline: "ゲストの声", shareTitle: "テラスで食事をされましたか?", shareSub: "レビューを残していただけると、このプロジェクトを広めるのに大変助かります。", shareCta: "レビューを書く", orGoogle: "またはGoogleで", shareSection: "ゲストでしたか?",
      emptyTitle: "最初のゲストの声が\nここに現れます。",
      emptySub: "Eternal City Viewはテラスの扉を開いたばかりです。ここで食事をされた方、あなたのレビューがこのプロジェクトを発見する人々に最初に読まれるものになります。",
      emptyCta: "最初の声をお寄せください",
    },
    reviews: { overline: "レビュー", formTitle: "あなたのレビュー", formSub: "簡単な確認後にレビューを公開いたします。心より感謝します — 口コミはこの仕事で最も大切なものです。", rating: "評価", name: "お名前", namePh: "例: 太郎 S.", origin: "都市", originPh: "例: 東京、ローマ…", text: "あなたの体験", textPh: "夜の思い出は何ですか?レシピ、雰囲気、眺め、何でも…", submit: "レビューを送る", sending: "送信中…", cancel: "キャンセル", success: "ありがとうございます!簡単な確認後にレビューを公開します。", error: "エラーが発生しました。もう一度お試しください。", errorRating: "1〜5星で評価を選んでください。", errorQuote: "10文字以上入力してください。" },
    booking: {
      overline: "予約", title: "夜を選んでください。", sub: "24時間以内に直接ご返信し、空き状況と詳細をお伝えします。",
      name: "氏名", email: "メールアドレス", phone: "電話 (WhatsApp)",
      classType: "どのパッケージ", coppie: "カップル · ロマンティック", gruppo: "スモールグループ", tartufo: "トリュフ & シャンパン", degustazione: "テイスティングディナー", evento: "プライベート/法人イベント",
      date: "希望日", pickDate: "日付を選ぶ", invalidEmail: "メールアドレスが無効です — ご確認のうえ再度お試しください", slot: "ご希望の時間", slotHint: "例:13:00ランチ、19:30ディナー — 一緒に調整します。",
      guests: "人数", message: "メッセージ (アレルギー、特別な機会、メモ)",
      submit: "リクエストを送信", sending: "送信中…", success: "リクエストを送信しました!24時間以内にご返信します。", error: "エラーが発生しました。もう一度お試しください。",
      confirmedTitle: "リクエストを受領しました!", confirmedSub: "ありがとうございます。24時間以内にメールまたはWhatsAppで直接ご返信し、空き状況と詳細を確認します。",
      depositTitle: "今すぐ日付を確保しますか?", depositSub: "予約を確定し、テラスをあなただけのために確保するため、Stripeで安全にデポジットをお支払いいただけます。", depositCta: "デポジットを支払う", depositSecure: "Stripeによる安全な決済", newBooking: "新しいリクエスト",
      payButton: "支払いに進む", payAmount: "デポジット 50€", payHint: "安全な決済のためStripeに移動します。",
      paidTitle: "予約が確定しました!", paidSub: "デポジットが確認され、テラスの日程が正式に確保されました。体験の48時間前に、正確な住所とすべての詳細をメールでお送りします。",
      cancelTitle: "支払いがキャンセルされました",
      cancelSub: "料金は請求されていません。リクエストは保留中です:後ほど決済を完了するか、WhatsAppでご連絡ください。",
      retry: "決済を再試行", backHome: "ホームへ戻る", checkingPayment: "支払いを確認中…",
    },
    faq: {
      overline: "よくある質問", title: "予約前に。",
      items: [
        { q: "テラスはどこにありますか?", a: "歴史地区の中心、スペイン広場からすぐです。確定時に正確な住所をお送りします。" },
        { q: "含まれるものは?", a: "アペリティーボ、すべての食材、カステッリのワイン、水、コーヒー。隠れた費用はありません。" },
        { q: "ベジタリアン / アレルギー?", a: "もちろんです。メッセージにご記入ください、メニューを調整します — シェフですから問題ありません。" },
        { q: "雨が降ったら?", a: "テラスには屋根のあるエリアがあります。本格的な悪天候の場合はキッチンに移動しますが、こちらも体験の一部です。" },
        { q: "支払い方法は?", a: "確定時に小額の前金を銀行振込またはPayPalでお願いします。残額は当日、現金またはカードで。" },
        { q: "最少人数は?", a: "2名から。クッキングクラスは最大6名、試食コースは最大8名です。" },
      ],
    },
    google: { overline: "Googleレビュー", basedOn: "{{n}}件の認証済みレビューに基づく", verifiedOnGoogle: "Googleで認証済み", writeReview: "レビューを書く" },
    footer: { tagline: "プライベート料理体験 · スペイン広場、ローマ", rights: "全著作権所有。", contacts: "お問い合わせ", cookiePolicy: "クッキーポリシー", cookieSettings: "クッキー設定" },
    cookies: {
      bannerTitle: "クッキーを使用しています",
      bannerBody: "サイトの機能に必要なクッキーと、お客様の同意に基づき利用状況を把握するための分析クッキーを使用します。広告・プロファイリング用のクッキーは使用しません。",
      readPolicy: "クッキーポリシーを読む",
      acceptAll: "すべて許可",
      rejectAll: "拒否",
      customize: "カスタマイズ",
      prefsOverline: "設定",
      prefsTitle: "クッキーを管理",
      prefsSub: "許可するクッキーを選択してください。フッターのリンクからいつでも変更できます。",
      necessaryTitle: "必須クッキー",
      necessaryDesc: "サイトの動作(言語、設定、安全な決済)に不可欠です。同意は不要です。",
      analyticsTitle: "分析クッキー",
      analyticsDesc: "Google AnalyticsとPostHogで匿名の利用状況を測定し、サイトを改善します。IPは匿名化されます。",
      alwaysActive: "常に有効",
      savePrefs: "設定を保存",
    },
    cookiePolicy: {
      overline: "法的情報",
      title: "クッキーポリシー",
      lastUpdated: "最終更新",
      updateDate: "2026年2月",
      back: "ホームに戻る",
      intro: "本クッキーポリシーは、アレッサンドロ・ピヴァーノが運営するeternalcityview.com(以下「本サイト」)が使用するクッキーおよび類似技術について説明します。本サイトは、明示的な同意なしに必須ではないクッキーを設置しません。",
      whatAreTitle: "クッキーとは",
      whatAreBody: "クッキーとは、訪問したサイトから端末に送信され保存される小さなテキストファイルで、次回の訪問時に同じサイトへ送り返されます。設定を保存するために類似の技術(localStorage)も使用します。",
      typesTitle: "使用するクッキーの種類",
      necessaryTitle: "技術的クッキー(必須)",
      necessaryBody: "本サイトの動作、選択された言語の保存、Stripeによる安全な決済処理に必要です。GDPRに基づき同意は不要です。",
      analyticsTitle: "分析クッキー(任意)",
      analyticsBody: "Google Analytics 4およびPostHogを使用して、本サイトの利用状況(閲覧ページ、セッション時間、デバイス、参照元)に関する集計・匿名情報を収集します。IPは匿名化されます。これらのクッキーはご同意いただいた場合のみ設置されます。",
      tableTitle: "本サイトで使用するクッキー",
      thName: "名前",
      thProvider: "提供元",
      thPurpose: "目的",
      thDuration: "有効期間",
      rowGaPurpose: "集計された匿名の利用統計",
      rowPhPurpose: "プロダクト分析と匿名化されたセッション記録",
      rowConsentPurpose: "クッキー設定を保存",
      rowLangPurpose: "選択された言語を保存",
      rowStripePurpose: "安全な決済処理(デポジット)",
      duration2y: "2年",
      duration1y: "1年",
      duration6m: "6ヶ月",
      durationPersistent: "永続",
      manageTitle: "同意の管理方法",
      manageBody: "以下のボタンをクリックすることで、いつでも設定を変更または撤回できます。",
      manageCta: "クッキー設定を管理",
      browserNote: "ブラウザ(Chrome、Safari、Firefox、Edgeなど)の設定から直接クッキーをブロックまたは削除することもできます。技術的クッキーを無効にすると、本サイトの正常な動作に影響する場合があります。",
      rightsTitle: "お客様の権利(GDPR)",
      rightsBody: "EU規則2016/679(GDPR)に基づき、個人データへのアクセス、訂正、削除、制限、可搬性、および異議申立ておよび監督当局への苦情申立ての権利があります。",
      contactTitle: "お問い合わせ",
      contactBody: "本クッキーポリシーまたはデータ処理に関するご質問は、以下までご連絡ください:",
    },
    floating: { question: "ちょっとした質問?", sub: "WhatsAppでお気軽にどうぞ、直接ご返信します。", cta: "WhatsAppを開く", greeting: "アレッサンドロさん、テラスでの料理体験について教えてください。", emailSub: "メールがよろしいですか?ご連絡ください、数時間以内にご返信いたします。", emailCta: "メールを開く", emailSubject: "テラスでの料理体験に関するお問い合わせ", emailBody: "アレッサンドロさん、\n\nテラスでの料理体験について教えてください。\n\nよろしくお願いします、" },
    admin: {
      addReview: "+ レビューを追加", cancel: "キャンセル", publish: "公開", addReviewValidation: "名前、都市、テキスト(10文字以上)を入力してください。", addReviewSuccess: "レビューを公開しました", reviewLanguage: "言語",
      gallery: "ギャラリー", uploadPhotos: "写真をアップロード", noPhotos: "まだ写真がありません。",
      title: "管理", loginTitle: "ログイン", password: "パスワード", login: "入る", logout: "ログアウト",
      bookings: "予約", reviewsTitle: "レビュー", noBookings: "予約はありません。", noReviews: "レビューはありません。", wrongPassword: "パスワードが正しくありません。",
      columns: { date: "日付", slot: "時間", class: "体験", guests: "人数", name: "名前", contact: "連絡先", message: "メモ", received: "受信日", status: "状態", actions: "操作" },
      reviewColumns: { rating: "評価", name: "名前", origin: "都市", quote: "本文", received: "受信日", status: "状態", actions: "操作" },
      statuses: { pending: "保留中", abandoned: "未完了(放棄)", expired: "期限切れ", pending_payment: "支払い待ち", failed: "失敗", confirmed: "確定", cancelled: "キャンセル", approved: "承認済", rejected: "拒否" },
      confirm: "確定", cancel: "キャンセル", delete: "削除", approve: "承認", reject: "拒否", all: "すべて",
    },
  },
};

export const LANGUAGES = [
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "ja", label: "日本語", flag: "🇯🇵" },
];

const STORAGE_KEY = "ecv_lang";

const LanguageContext = createContext({ lang: "it", setLang: () => {}, t: DICT.it });

export function LanguageProvider({ children }) {
  const initial = (() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved && DICT[saved]) return saved;
      const browser = (navigator.language || "en").slice(0, 2);
      return DICT[browser] ? browser : "en";
    } catch {
      return "en";
    }
  })();
  const [lang, setLangState] = useState(initial);
  const setLang = (code) => {
    if (!DICT[code]) return;
    setLangState(code);
    try { localStorage.setItem(STORAGE_KEY, code); } catch {}
    if (typeof document !== "undefined") document.documentElement.lang = code;
  };
  if (typeof document !== "undefined") document.documentElement.lang = lang;
  const value = { lang, setLang, t: DICT[lang] };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useI18n() {
  return useContext(LanguageContext);
}

export const BRAND = {
  name: "Eternal City View",
  email: "bookings@eternalcityview.com",
  phone: "+39 366 875 1468",
  whatsapp: "393668751468",
  zone: "Piazza di Spagna, Roma",
  stripeLink: "https://buy.stripe.com/cNieVch291VacHS9MDbII00",
  instagram: "https://www.instagram.com/eternalcityview",
  instagramHandle: "@eternalcityview",
  googleProfile: "https://g.page/r/CRP_Rzbd3gC2EBI/review",
};

export const MEDIA = {
  hero: "https://customer-assets.emergentagent.com/job_roma-cooking-reserve/artifacts/kuovidls_A47ED45D-8FD2-4AD5-8A23-EA2F0BD81D6C.png",
  pasta: "https://customer-assets.emergentagent.com/job_roma-cooking-reserve/artifacts/g32m10i2_IMG_7523.jpeg",
  tasting: "https://images.pexels.com/photos/34797458/pexels-photo-34797458.jpeg?auto=compress&cs=tinysrgb&w=1600",
  dessert: "https://customer-assets.emergentagent.com/job_roma-cooking-reserve/artifacts/ltpy7que_B5FC5EED-8E54-4DA5-B8BF-059CD7ABD999.png",
  terrace: "https://customer-assets.emergentagent.com/job_roma-cooking-reserve/artifacts/ui8yus1r_02D66F57-86F9-4096-BFE1-49ABAD39BC76.png",
  sunset: "https://customer-assets.emergentagent.com/job_roma-cooking-reserve/artifacts/gwm54w6i_74E531C1-42DF-4C30-9F99-F2BC5C26E264.png",
  apericena: "https://customer-assets.emergentagent.com/job_roma-cooking-reserve/artifacts/gwm54w6i_74E531C1-42DF-4C30-9F99-F2BC5C26E264.png",
  host: "https://customer-assets.emergentagent.com/job_roma-cooking-reserve/artifacts/g32m10i2_IMG_7523.jpeg",
  gallery: [
    { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_roma-cooking-reserve/artifacts/0gtc92l1_IMG_8660.webp", alt: "Cooking class al tramonto: ospiti e chef sul terrazzo", aspect: "portrait" },
    { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_roma-cooking-reserve/artifacts/2rb2grps_IMG_8578.webp", alt: "Alessandro con quattro piatti di pasta fresca appena impiattati", aspect: "portrait" },
    { src: "https://customer-assets.emergentagent.com/job_roma-cooking-reserve/artifacts/pah0k5ww_IMG_7537.jpeg", alt: "Tavolo apparecchiato sul terrazzo al tramonto con vista sui tetti di Roma", aspect: "portrait" },
    { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_roma-cooking-reserve/artifacts/dantgic7_IMG_8663.webp", alt: "Famiglia a cena sul terrazzo con piatti di pasta", aspect: "portrait" },
    { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_roma-cooking-reserve/artifacts/fti7ipyl_IMG_8585.webp", alt: "Ospite prepara l'impasto mentre lo chef supervisiona", aspect: "portrait" },
    { src: "https://customer-assets.emergentagent.com/job_roma-cooking-reserve/artifacts/g32m10i2_IMG_7523.jpeg", alt: "Pasta fresca appena tirata a mano", aspect: "portrait" },
    { src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_roma-cooking-reserve/artifacts/buxjbx0q_DJI_20260723_210809_226.webp", alt: "Tavolo dell'apericena sul terrazzo al tramonto", aspect: "landscape" },
    { src: "https://customer-assets.emergentagent.com/job_roma-cooking-reserve/artifacts/gwm54w6i_74E531C1-42DF-4C30-9F99-F2BC5C26E264.png", alt: "Tramonto su Piazza di Spagna dal terrazzo", aspect: "portrait" },
    { src: "https://customer-assets.emergentagent.com/job_roma-cooking-reserve/artifacts/kuovidls_A47ED45D-8FD2-4AD5-8A23-EA2F0BD81D6C.png", alt: "Panorama dei tetti di Roma al tramonto dal terrazzo", aspect: "portrait" },
  ],
};
